/* eslint-disable no-template-curly-in-string */
import {
  CONTRATO_EDIT_ETAPA_ANALISE_OPERACIONAL,
  CONTRATO_EDIT_ETAPA_ARQUIVOS,
  CONTRATO_EDIT_ETAPA_DADOS,
  CONTRATO_EDIT_ETAPA_DOWNLOAD_CHECKLISTS,
  CONTRATO_EDIT_ETAPA_VALIDACAO,
} from '../../library/ContratoEditEtapas';
import {
  CONTRATO_TIPO_ASSESSOR_NAME,
  CONTRATO_TIPO_ENTE_PRIVADO_NAME,
  CONTRATO_TIPO_ENTE_PRIVADO_REDE_NAME,
  CONTRATO_TIPO_ENTE_PUBLICO_NAME,
  FLUXO_TIPO_CENTRALIZADO_NAME,
  FLUXO_TIPO_DESCENTRALIZADO_NAME,
} from '../../library/ContratoTipos';
import {
  CONTRATO_VERSAO_ADITIVO_NAME,
  CONTRATO_VERSAO_CONTRATO_NAME,
  CONTRATO_VERSAO_DISTRATO_NAME,
} from '../../library/ContratoVersoes';
import {
  PROFILE_PUFV_ADMINISTRADOR,
  PROFILE_PUFV_ASSESSOR_PEDAGOGICO,
  PROFILE_PUFV_ASSESSOR_PEDAGOGICO_GESTOR,
  PROFILE_PUFV_CENTRAL,
  PROFILE_PUFV_COOPERATIVA,
  PROFILE_PUFV_COORDENADOR_LOCAL,
  PROFILE_PUFV_OPERACIONAL,
  PROFILE_PUFV_PROFESSOR,
  PROFILE_PUFV_PROFESSOR_GESTOR,
} from '../../library/Profiles';
import {
  BAIRRO_MIN_LENGTH,
  INEP_LENGTH,
  NUMERO_MAX_LENGTH,
} from '../../utils/ValidationUtils';
import { CHANGED_LANGUAGE_ACTION } from './LanguageActions';

export const LANGUAGE_BR_VALUES = {
  locale: 'pt-BR',
  currency: 'BRL',
  currencyPrefix: 'R$ ',
  languages: {
    br: 'Português',
    en: 'Inglês',
  },
  authRender: {
    preloader: 'Carregando dados do usuário',
  },
  perfilNomes: {
    [PROFILE_PUFV_ADMINISTRADOR.id]: 'Administrador',
    [PROFILE_PUFV_CENTRAL.id]: 'Central',
    [PROFILE_PUFV_COOPERATIVA.id]: 'Cooperativa',
    [PROFILE_PUFV_ASSESSOR_PEDAGOGICO.id]: 'Assessor Pedagógico',
    [PROFILE_PUFV_ASSESSOR_PEDAGOGICO_GESTOR.id]: 'Assessor Pedagógico Gestor',
    [PROFILE_PUFV_COORDENADOR_LOCAL.id]: 'Coordenador Local',
    [PROFILE_PUFV_PROFESSOR_GESTOR.id]: 'Professor Gestor',
    [PROFILE_PUFV_PROFESSOR.id]: 'Professor',
    [PROFILE_PUFV_OPERACIONAL.id]: 'Operacional',
  },
  preCadastro: 'Pré Etapa',
  etapa1: 'Etapa 1 - Justificativa/Saberes Curriculares',
  etapa2_1: 'Etapa 2.1 - Antes da Expedição',
  etapa2_2: 'Etapa 2.2 - Depois da Expedição',
  etapa3: 'Etapa 3 - Definição do Tema/Título do Projeto',
  etapa4: 'Etapa 4 - Índices Inicial e Formativo',
  etapa5:
    'Etapa 5 - Articulação com o Currículo/Mobilização dos Saberes Escolares',
  etapa5card2PrincipiosHint:
    'Os princípios Cooperação e Cidadania não devem ser desmarcados, pois são os princípios essenciais do programa.',
  etapa6: 'Etapa 6 - Comunidade de Aprendizagem',
  etapa7: 'Etapa 7 - Índice Final',
  etapa8: 'Etapa 8 - Mostra Pedagógica/Cooperativa',
  etapa9: 'Etapa 9 - Revisão e Finalização',
  paginaInicial: 'Página Inicial',
  novoProjeto: 'Novo Projeto',
  gerarGrafico: 'Gerar Gráfico',
  exportReport: 'Exportar relatório',
  proxima: 'Próxima',
  anterior: 'Anterior',
  concluirEtapa: 'Concluir Etapa',
  concluirEAvancarEtapa: 'Concluir e Avançar Etapa',
  avancarEtapa: 'Avançar Etapa',
  despesaAttachLockedHint:
    'Você precisa cadastrar os dados antes de poder inserir algum comprovante de despesa.',
  removerReembolsoHint: 'Remover reembolso',
  removerReembolsoModalTitle: 'Removendo reembolso',
  removerReembolsoModalDescription:
    'Você deseja remover o reembolso "${1}" da agenda do dia "${2}"',
  removerReembolsoModalConfirmLabel: 'Remover',
  removerDadosDaEscolaModalTitle: 'Removendo período',
  removerDadosDaEscolaTitle: 'Remover período',
  removerDadosDaEscolaModalDescription: 'Você deseja remover o período "${1}"?',
  removerDadosDaEscolaModalConfirmLabel: 'Remover',
  removerProjetoHint: 'Remover projeto',
  removerProjetoModalTitle: 'Removendo projeto',
  removerProjetoModalDescription: 'Você deseja remover o projeto "${1}"',
  removerProjetoModalConfirmLabel: 'Remover',
  ativarProjeto: 'Ativar projeto',
  ativarProjetoTitle: 'Ativar projeto',
  ativarProjetoContent: 'Você realmente deseja ativar este projeto?',
  desativarProjeto: 'Desativar projeto',
  desativarProjetoTitle: 'Desativar projeto',
  desativarProjetoContent: 'Você realmente deseja desativar este projeto?',
  escola: 'Escola',
  carregandoEscolas: 'Carregando escolas...',
  cooperativa: 'Cooperativa',
  fechar: 'Fechar',
  naoMostrarNovamente: 'Não mostrar novamente',
  allCooperativas: 'Todas as cooperativas',
  allTiposFluxo: 'Todos os fluxos',
  allTiposContrato: 'Todos os tipos de contrato',
  allCidades: 'Todas as cidades',
  todosEstados: 'Todos os estados',
  loading: 'Carregando...',
  iniciarContratacaoLabel: 'Iniciar Contratação',
  continuarContratacaoLabel: 'Continuar com a Contratação',
  tiposContratoLabel: 'Tipos de Contrato',
  tipoDeDocumento: 'Tipos de documentos*',
  selecioneUmTipoDeContrato: 'Selecione um tipo de contrato',
  cooperativasLabel: 'Cooperativas',
  centraisLabel: 'Centrais',
  erroAoConverterResposta: 'Erro ao converter a resposta de erro',
  erroAoCriarRelatório: 'Erro ao criar relatório',
  situacoesLabel: 'Situacoes',
  programaEducacionalLabel: 'Programa Educacional',
  todasAsSituacoesLabel: 'Todas as situações',
  todosOsProgramasLabel: 'Todos os Programas',
  programasEducacionais: 'Programas educacionais*',
  modalAvisoGenericTitle: "Pesquisa de Expêriencia - Perfis",
  selecionarEscolaLabel: 'Selecionar escola',
  assessorPedagogicoLabel: 'Assessor Pedagógico',
  cooperativasFilterLabel: 'Cooperativa',
  tipoRelatoriosLabel: 'Tipo de relatório',
  tipoRelatoriosPlaceholder: 'Selecione o tipo de relatório',
  tipoRelatoriosProjetosLabel: 'Projetos A União Faz a Vida',
  tipoRelatoriosDadosCadastraisLabel: 'Dados Cadastrais',
  tipoRelatoriosDadosGeraisLabel: 'Dados Gerais da Cooperativa',
  tipoRelatoriosDadosDoProgramaLabel: 'Dados dos Programas',
  tipoRelatorioAssessoria: 'Agenda dos Assessores Pedagógicos',
  tipoRelatorioIDEB: 'Dados do IDEB',
  tipoRelatorioContratos: 'Contratos',
  tipoRelatorioEscolas: 'Escolas',
  naoInformado: '-',
  assessoresPedagogicos: 'Assessor(es) pedagógico(s)',
  carregandoAssessores: 'Carregando assessores pedagógicos...',
  carregandoPrinciposValores: 'Carregando princípios e valores...',
  preTitulo: 'Pré título',
  tituloProjeto: 'Título do projeto',
  professores: 'Professor(es)',
  educadores: 'Educadores',
  carregandoProfessores: 'Carregando professores...',
  carregandoEducadores: 'Carregando educadores...',
  etapaDeEnsino: 'Etapa(s) de ensino',
  loadingEtapasEnsinoList: 'Carregando etapas de ensino...',
  turma: 'Turma(s)',
  quantidadeDeAlunos: 'Quantidade de alunos',
  justificativa:
    'Justificativa (Por quê? Quais saberes curriculares pretendo trabalhar?)',
  cienciaCoordenador: 'Ciência do Coordenador Pedagógico',
  direitoImagem:
    'Me responsabilizo pela autorização de imagens e vídeos anexadas neste projeto',
  direitoImagemHint:
    'Lembrando que as imagens e vídeos exibidas devem possuir autorização de uso de imagem, conforme registrado anteriormente',
  consultaPublica: 'Consulta pública',
  descricaoPerguntaExploratoria: 'Pergunta exploratória',
  descricaoTerritorioInvestigado: 'Território a ser investigado',
  descricaoObjetivoExpedicao: 'Objetivo da expedição',
  descricaoExpedicao: 'Descrição da expedição (registro de experiências)',
  descricaoPerguntas:
    'Delimitar a temática e as perguntas que nortearão o projeto',
  nomeDoProjetoEtapa3: 'Inserir título do projeto',
  descricaoIndiceInicial: 'Descrição do índice inicial',
  descricaoIndiceFormativo: 'Descrição do índice formativo',
  descricaoComponenteCurricular:
    'Componente curricular ou campos de experiências',
  tipoAgendaLabel: 'Tipo de agenda',
  descricaoTipoAgendaLabel: 'Descreva o tipo de agenda',
  assuntoLabel: 'Assunto',
  assessorConvidadoLabel: 'Assessor Convidado',
  horaIntervaloLabel: 'Adicionar intervalo',
  assessoresPedagogicosLabel: 'Assessores Pedagógicos',
  dataAssessoriaLabel: 'Data da agenda',
  horaInicialLabel: 'Hora Inicial',
  horaFinalLabel: 'Hora Final',
  chTotalLabel: 'CH Total',
  atividadesLabel: 'Atividades',
  observacoesLabel: 'Observações',
  contratoCodigoLabel: 'Código do Contrato',
  centralizado: 'Centralizado',
  descentralizado: 'Descentralizado',
  fluxoDesconhecido: 'Fluxo desconhecido',
  assessor: 'Assessor',
  publico: 'Público',
  privado: 'Privado',
  enteDesconhecido: 'Ente desconhecido',
  pufv: 'PUFV',
  cooperacao: 'Cooperação',
  financas: 'Finanças',
  programaDesconhecido: 'Programa educacional desconhecido',
  descricaoReembolsoLabel: 'Descrição',
  descricaoAtividadeDesenvolvida: 'Atividades desenvolvidas',
  idPrincipiosValores: 'Princípios e valores',
  descricaoPrincipioValor:
    'Explique como estão sendo desenvolvidos os princípios e valores do Programa',
  erroDeletarPrincipioFixed:
    'Os princípios de "Cooperação" e "Cidadania" não podem ser desmarcados.',
  descricaoComunidadeAprendizagem:
    'Descrição da participação da comunidade de aprendizagem',
  apoiadores: 'Apoiadores',
  descricaoAtividadeIntegradora: 'Inserir como foi a atividade integradora',
  descricaoIndiceFinal: 'Inserir como foi o índice final/avaliação do projeto',
  descricaoMostraPedagogica:
    'Descrição da mostra pedagógica/cooperativa (Não obrigatório)',
  naoPreenchido: 'Não Preenchido',
  closeModal: 'Fechar janela',
  modalEvaluationHistoryTitle: 'Histórico de avaliações',
  relatoriosTitle: 'Relatórios',
  contratoStatusEmEdicao: 'Em Edição',
  contratoStatusEmAnaliseOperacional: 'Em Análise',
  contratoStatusAguardandoAssinatura: 'Aguardando Assinatura',
  contratoStatusNaoIniciado: 'Não Iniciado',
  contratoStatusVigente: 'Vigente',
  contratoStatusEncerrado: 'Encerrado',
  contratoStatusDesativado: 'Desativado',
  contratoStatusExtrato: 'Aguardando extrato',
  contratoStatusAprovado: 'Aprovado',
  contratoStatusRejeitado: 'Ponto de atenção',
  projectStatusRascunho: 'Sem preenchimento',
  projectStatusPendente: 'Pendente de aprovação',
  projectStatusAprovado: 'Aprovado',
  projectStatusEmAndamento: 'Em andamento',
  projectStatusRejeitado: 'Ponto de atenção',
  aprovarDocumentoContrato: 'Aprovar documento',
  reprovarDocumentoContrato: 'Ponto de atenção',
  historicoAnaliseOperacionaldocumentoAprovado: 'Aprovado',
  historicoAnaliseOperacionaldocumentoRejeitado: 'Ponto de Atenção',
  projectStatus: 'Situação do projeto',
  projectAtivo: 'Ativo',
  projectSim: 'Sim',
  projectNao: 'Não',
  projectAmbos: 'Ambos',
  etapasEnsino: 'Etapa de ensino',
  projectStatusProfessorLabel: 'Situação',
  projectStatusProfessorValueAguardandoAprovacao: 'Aguardando Aprovação',
  projectStatusProfessorValueAprovado: 'Aprovado',
  projectStatusProfessorValueInativa: 'Inativado',
  projectStatusProfessorValueRejeitado: 'Rejeitado',
  projectStatusCordenadorLabel: 'Situação',
  projectStatusCordenadorAtivado: 'Ativado',
  projectStatusCordenadorInativado: 'Inativado',
  projectStatusAssessorAtivado: 'Ativado',
  projectStatusAssessorInativado: 'Inativado',
  projectFormacaoAssessorLabel: 'Formação acadêmica',
  escolaEditTipoDeInstituicaoLabel: 'Tipo de Instituição',
  escolaEditEtapasDaEducacaoLabel: 'Etapa da Educação',
  escolaTipoDeInstituicaoLabel: 'Tipos de Instituição',
  escolaEtapasDaEducacaoLabel: 'Etapas da Educação',
  escolaEditTipoDeInstituicaoAll: 'Todas as instituições',
  escolaEditTipoDeInstituicaoMunicipal: 'Municipal',
  escolaEditTipoDeInstituicaoEstadual: 'Estadual',
  escolaEditTipoDeInstituicaoPrivada: 'Privada',
  escolaEditEtapasDaEducacaoInfantil: 'EDUCAÇÃO INFANTIL',
  escolaEditEtapasDaEducacaoEnsinoFundamental: 'ENSINO FUNDAMENTAL',
  escolaEditEtapasDaEducacaoEnsinoMedio: 'ENSINO MÉDIO',
  escolaEditEtapasDaEducacaoEspecializado: 'ESPECIALIZADO',
  escolaEditEtapasDaEducacaoEja: 'EJA',
  escolaEditEtapasDaEducacaoOutro: 'OUTRO',
  escolaEditModalidadeRural: 'RURAL',
  escolaEditModalidadeQuilombola: 'QUILOMBOLA',
  escolaEditModalidadeIndigena: 'INDÍGENA',
  escolaEditModalidadeEspecializada: 'ESPECIALIZADA',
  ProjectFilterNomeDeProjeto: 'Nome de Projeto',
  ProjectFilterProfessor: 'Professor',
  ProjectFilterAssessorPedagogico: 'Assessor(a) pedagógico(a)',
  ProjectFilterInstituicao: 'Instituição',
  educacaoInfantilBebes: 'EDUCAÇÃO INFANTIL – BEBÊS (BERÇÁRIO)',
  educacaoInfantilCriancasBemPequenasMaternal:
    'EDUCAÇÃO INFANTIL – CRIANÇAS BEM PEQUENAS (MATERNAL)',
  educacaoInfantilCriancasBemPequenasPreEscola:
    'EDUCAÇÃO INFANTIL – CRIANÇAS PEQUENAS (PRÉ-ESCOLA)',
  educacaoFundamentalUm: '1º ANO EF',
  educacaoFundamentalDois: '2º ANO EF',
  educacaoFundamentalTres: '3º ANO EF',
  educacaoFundamentalQuatro: '4º ANO EF',
  educacaoFundamentalCinco: '5º ANO EF',
  educacaoFundamentalSeis: '6º ANO EF',
  educacaoFundamentalSete: '7º ANO EF',
  educacaoFundamentalOito: '8º ANO EF',
  educacaoFundamentalNove: '9º ANO EF',
  educacaoEnsinoMedioUm: '1º ANO EM',
  educacaoEnsinoMedioDois: '2º ANO EM',
  educacaoEnsinoMedioTres: '3º ANO EM',
  projectEtapasEnsino: 'Situação do projeto',
  contratoStatus: 'Filtrar por situação do contrato',
  filtrar: 'Filtrar',
  sair: 'Sair',
  contratoEstados: 'Estados',
  contratoCidades: 'Cidades',
  tipoContrato: 'Tipo de contrato',
  escolhaTipoContrato: 'Escolha o tipo de contrato:',
  dadosCooperativa: 'Dados da cooperativa',
  DadosContratadoOuContratante: 'Dados do contratado ou contratante',
  preenchaDadosCooperativa: 'Preencha os dados da cooperativa desse contrato:',
  dadosContratante: 'Dados do contratante',
  preenchaDadosContratante: 'Preencha os dados do contratante. Dados do Ente / pessoa, tempo do contrato, etc:',
  preenchaDadosContratanteAssessor: 'Preencha os dados do contratado. Dados do Assessor, tempo do contrato, etc:',
  preenchaDadosContratanteEntePublico: 'Preencha os dados do contratado. Dados do Ente público, tempo do contrato, etc:',
  preenchaDadosContratanteEntePrivado: 'Preencha os dados do contratado. Dados do Ente privado, tempo do contrato, etc:',
  dataFimError: 'A data de fim não pode ser menor que a data de início.',
  dataInicioError: 'A data de início não pode ser maior que a data final.',
  dataInicioIgualDataFimError: "A data de início não pode ser igual à data de fim.",
  dataFimIgualDataInicioError: "A data de fim não pode ser igual à data de início.",
  preenchaDadosContratado: 'Preencha os dados do contratado. Dados do Ente / pessoa, tempo do contrato, etc:',
  dadosContratado: 'Dados do contratado',
  documentos: 'Documentos',
  excluirDocumentos: 'Excluir documentos',
  excluir: 'Excluir',
  facaDownloadEUploadContrato: 'Faça download e upload dos documentos do seu contrato',
  escolhaArquivoContratoAssinado: 'Escolha o arquivo do documento assinado que você irá subir:',
  projectCoop: 'Filtrar por cooperativa',
  filterTipoContrato: 'Filtrar por tipo de contrato',
  filterTipoFluxo: 'Filtrar por tipo de fluxo',
  tipoEntidadePessoa: 'Tipo de entidade / pessoa*',
  tipoFluxoEntidade: 'Tipo de fluxo*',
  filterAssessores: 'Filtrar por Assessores Pedagógicos',
  filterAssessor: 'Filtrar por Assessor Pedagógico',
  filterData: 'Filtrar por data',
  allStatus: 'Todas as situações',
  status: 'Situações',
  todosCoop: 'Todas as cooperativas',
  labelProgramasEducacionais: 'Programas Educacionais',
  nenhumaCentral: 'Nenhuma central selecionada',
  nenhumaCidade: 'Nenhuma cidade selecionada',
  nenhumEstadoCarregado: 'Nenhum estado carregado',
  nenhumaCidadeCarregada: 'Nenhuma cidade carregada',
  nenhumaEscolaCarregada: 'Nenhuma escola carregada',
  nenhumEstado: 'Nenhum estado selecionado',
  todosEscolas: 'Todas as escolas',
  todosPeriodos: 'Todos os períodos',
  todosAssessores: 'Todos os assessores pedagógicos',
  selecioneAssessor: 'Selecione o assessor pedagógico',
  selectPeriodo: 'Selecione um período',
  perfis: 'Perfis',
  todosPerfis: 'Todos os perfis',
  modalAuthGenericErrorTitle: 'Erro de autenticação',
  modalAuthAccessErrorTitle: 'Acesso negado',
  modalAuthTokenExpiredTitle: 'Sessão Expirada',
  modalAuthTokenExpiredDescription:
    'Sua sessão expirou. Por favor, faça login novamente.',
  modalAuthTokenExpiredCloseButton: 'Fazer Login',
  modalAuthAccessErrorDescription:
    'Você não possui acesso a esta ferramenta. Para solicitar acesso, por favor, utilize o',
  cadastroDeContratos: 'Cadastro de contratos',
  escolhaDefluxoEntidadeCadastroNovoContrato: 'Escolha o fluxo e entidade que deseja cadastrar um novo contrato:',
  modalAuthAccessErrorCloseButton: 'Tente com outro usuário',
  modalApproveTitle: 'Aprovação da Etapa',
  modalDisapproveTitle: 'Ponto de atenção',
  evaluationTextLabel: 'Observações:',
  reviewButton: 'Revisão',
  approveButton: 'Aprovar etapa',
  deletarEventoLabel: 'Excluir Agenda',
  aprovarEventoLabel: 'Aprovar Agenda',
  desaprovarEventoLabel: 'Desaprovar Agenda',
  disapproveButton: 'Ponto de atenção na etapa',
  approveButtonHint: 'Aprovar etapa',
  disapproveButtonHint: 'Ponto de atenção na etapa',
  historyButton: 'Visualizar comentários da etapa',
  upload: 'Upload',
  uploadLabelButton: 'Enviar fotos e vídeos',
  periodoInicial: 'Período Inicial',
  periodoFinal: 'Período Final',
  uploadLabel: 'Upload',
  uploadingLabel: 'Carregando ${1}%',
  downloadingLabel: 'Carregando ${1}%',
  downloadLabel: 'Download',
  downloadError: 'Erro ao tentar efetuar um download.',
  uploadFileSuccess: 'Upload do arquivo "${1}" feito com sucesso.',
  uploadFileError: 'Erro ao tentar efetuar o upload do arquivo "${1}".',
  downloadFileError: 'Erro ao tentar efetuar o download do arquivo "${1}".',
  notFoundChecklistFiles:
    'Nenhum arquivo de checklist disponível para download.',
  notFoundModeloFiles: 'Nenhum arquivo de modelo disponível para download.',
  estadoEntePublicoHint: 'Selecione o estado do Ente Público',
  cidadeEntePublicoHint: 'Selecione a cidade do Ente Público',
  lastModification: 'Última atualização - ',
  stepsHistoryFor: 'Por: ${1}',
  etapa9Documentos: 'Fotos e vídeos',
  uploadAreaText: 'Clique ou arraste seus arquivos aqui...',
  likeProfessorHint: 'Aprovar usuário do professor ${1}.',
  dislikeProfessorHint: 'Rejeitar usuário do professor ${1}.',
  editProfessorHint: 'Editar usuário do professor ${1}.',
  activateProfessorHint: 'Ativar usuário do professor ${1}.',
  deactivateProfessorHint: 'Desativar usuário do professor ${1}.',
  legendProfessoresResultSingularEmpty: 'Mostrando ${1} de ${2} resultado.',
  legendProfessoresResultPluralEmpty: 'Mostrando ${1} de ${2} resultados.',
  legendProfessoresResultSingular:
    'Mostrando ${1} de ${2} resultado buscando por "${3}".',
  legendProfessoresResultPlural:
    'Mostrando ${1} de ${2} resultados buscando por "${3}".',
  legendCoordenadoresResultSingularEmpty: 'Mostrando ${1} de ${2} resultado.',
  legendCoordenadoresResultPluralEmpty: 'Mostrando ${1} de ${2} resultados.',
  legendCoordenadoresResultSingular:
    'Mostrando ${1} de ${2} resultado buscando por "${3}".',
  legendCoordenadoresResultPlural:
    'Mostrando ${1} de ${2} resultados buscando por "${3}".',
  editCoordenadorHint: 'Editar usuário do coordenador local ${1}.',
  activateCoordenadorHint: 'Ativar usuário do coordenador local ${1}.',
  deactivateCoordenadorHint: 'Desativar usuário do coordenador local ${1}.',
  editAssessorHint: 'Editar usuário do assessor pedagógico ${1}.',
  activateAssessorHint: 'Ativar usuário do assessor pedagógico ${1}.',
  deactivateAssessorHint: 'Desativar usuário do assessor pedagógico ${1}.',
  openDadosEscolaHint: 'Cadastrar dados da escola ${1}.',
  openIdebHint: 'Abrir IDEB da escola ${1}.',
  editEmpresaHint: 'Editar empresa ${1}.',
  removeEmpresaHint: 'Excluir empresa ${1}.',
  editEscolaHint: 'Editar escola ${1}.',
  activateEscolaHint: 'Ativar escola ${1}.',
  deactivateEscolaHint: 'Desativar escola ${1}.',
  legendProjetosResultSingularEmpty: 'Mostrando ${1} de ${2} resultado.',
  legendProjetosResultPluralEmpty: 'Mostrando ${1} de ${2} resultados.',
  legendProjetosResultSingular:
    'Mostrando ${1} de ${2} resultado buscando por "${3}".',
  legendProjetosResultPlural:
    'Mostrando ${1} de ${2} resultados buscando por "${3}".',
  legendReembolsosResultSingularEmpty: 'Mostrando ${1} de ${2} resultado.',
  legendReembolsosResultPluralEmpty: 'Mostrando ${1} de ${2} resultados.',
  legendReembolsosResultSingular:
    'Mostrando ${1} de ${2} resultado buscando por "${3}".',
  legendReembolsosResultPlural:
    'Mostrando ${1} de ${2} resultados buscando por "${3}".',

  legendContratosResultSingular:
    'Mostrando ${1} de ${2} resultado buscando por "${3}".',
  legendContratosResultPlural:
    'Mostrando ${1} de ${2} resultados buscando por "${3}".',
  legendContratosResultSingularEmpty: 'Mostrando ${1} de ${2} resultado.',
  legendContratosResultPluralEmpty: 'Mostrando ${1} de ${2} resultados.',
  legendTemplatesContratosResultSingularEmpty:
    'Mostrando ${1} template de contrato.',
  legendTemplatesContratosResultPluralEmpty:
    'Mostrando ${1} templates de contratos.',
  legendAssessoresResultSingularEmpty: 'Mostrando ${1} de ${2} resultado.',
  legendAssessoresResultPluralEmpty: 'Mostrando ${1} de ${2} resultados.',
  legendAssessoresResultSingular:
    'Mostrando ${1} de ${2} resultado buscando por "${3}".',
  legendAssessoresResultPlural:
    'Mostrando ${1} de ${2} resultados buscando por "${3}".',
  legendEscolasResultSingularEmpty: 'Mostrando ${1} de ${2} resultado.',
  legendEscolasResultPluralEmpty: 'Mostrando ${1} de ${2} resultados.',
  legendEscolasResultSingular:
    'Mostrando ${1} de ${2} resultado buscando por "${3}".',
  legendEscolasResultPlural:
    'Mostrando ${1} de ${2} resultados buscando por "${3}".',

  legendEmpresasResultSingularEmpty: 'Mostrando ${1} de ${2} resultado.',
  legendEmpresasResultPluralEmpty: 'Mostrando ${1} de ${2} resultados.',
  legendEmpresasResultSingular:
    'Mostrando ${1} de ${2} resultado buscando por "${3}".',
  legendEmpresasResultPlural:
    'Mostrando ${1} de ${2} resultados buscando por "${3}".',
  notFoundEscolasWithCoops: 'Nenhuma escola encontrada.',
  notFoundAssessores: 'Nenhum assessor pedagógico encontrado.',
  noneSelectedCooperativa: 'Nenhuma cooperativa selecionada',
  noneSelectedAssessor: 'Nenhum assessor pedagógico selecionado',
  cadastroCoordenadorNome: 'Nome *',
  cadastroCoordenadorCelular: 'Celular *',
  cadastroCoordenadorEmail: 'E-mail *',
  cadastroCoordenadorMae: 'Nome da mãe',
  cadastroCoordenadorDataNascimento: 'Data de nascimento *',
  cadastroCoordenadorRG: 'RG',
  cadastroCoordenadorCPF: 'CPF *',
  cadastroCoordenadorCooperativa: 'Cooperativa *',
  cadastroCoordenadorEstado: 'Estado *',
  cadastroCoordenadorCidade: 'Cidade *',
  cadastroEmpresaNome: 'Nome *',
  cadastroEmpresaCNPJ: 'CNPJ *',
  cadastroEmpresaCep: 'CEP *',
  cadastroEmpresaEndereco: 'Endereço *',
  cadastroEmpresaNumero: 'Número',
  cadastroEmpresaComplemento: 'Complemento',
  cadastroEmpresaBairro: 'Bairro *',
  cadastroEmpresaEstado: 'Estado *',
  cadastroEmpresaCidade: 'Cidade *',
  dadosDaEscola: 'Dados da escola',
  empresaRequired: 'O campo "Empresa" é obrigatório',
  assessorRequired: 'O campo "Assessor" é obrigatório',
  arrasteESolteArquivosNaAreaOu: 'Arraste e solte os arquivos .pdf ou .doc nesta área ou',
  procureNoDispositivo: 'procure no dispositivo.',
  uploadArquivos: 'Upload de arquivos',
  pesquisa: 'Pesquisa',
  cadastroAssessorNome: 'Nome *',
  cadastroAssessorCelular: 'Celular *',
  cadastroAssessorEmail: 'E-mail *',
  cadastroAssessorMae: 'Nome da mãe',
  cadastroAssessorQualificacaoPlaceholder: 'ex.: Administração',
  cadastroAssessorAreaEstudo: 'Área de estudo',
  cadastroAssessorDataNascimento: 'Data de nascimento *',
  cadastroAssessorRG: 'RG',
  cadastroAssessorCPF: 'CPF *',
  cadastroAssessorCooperativa: 'Cooperativas *',
  cadastroAssessorProgramas: 'Programas educacionais em que atua *',
  cadastroAssessorCooperativaGestor: 'Cooperativa(s) em que é gestor',
  cadastroAssessorEmpresa: 'Empresa',
  cadastroAssessorFormacaoAcademica: 'Diploma *',
  cadastroAssessorSituacao: 'Situação *',
  cadastroAssessorEnsinoSuperior: 'Graduação',
  cadastroAssessorSituacaoAtivo: 'Ativo',
  cadastroAssessorSituacaoEmAndamento: 'Em andamento',
  cadastroAssessorEspecializacao: 'Pós-graduação',
  cadastroAssessorMestrado: 'Mestrado',
  cadastroAssessorDoutorado: 'Doutorado',
  cadastroAssessorUniaoFazAVida: 'A União faz a Vida',
  cadastroAssessorFinancasNaMochila: 'Finanças na Mochila',
  cadastroAssessorCooperativasEscolares: ' Cooperativas Escolares',
  duplicarDadosDaEscolaModalTitle: 'Duplicar Período',
  duplicarDadosDaEscolaModalDescription:
    'Você está duplicando o período "${1}":',
  duplicarDadosDaEscolaModalPeriodoLabel: 'Selecione um novo período',
  duplicarDadosDaEscolaModalCancel: 'Cancelar',
  duplicarDadosDaEscolaModalSubmit: 'Duplicar',
  cadastroContratoCooperativa: 'Cooperativa',
  cadastroContratoCNPJ: 'CNPJ',
  cadastroContratoEmail: 'E-mail',
  cadastroContratoCep: 'CEP',
  cadastroContratoEndereco: 'Endereço',
  cadastroContratoNumero: 'Número',
  cadastroContratoComplemento: 'Complemento',
  cadastroContratoBairro: 'Bairro',
  cadastroContratoEstado: 'Estado',
  cadastroContratoCidade: 'Cidade',
  cadastroContratoAssessor: 'Assessor',
  cadastroContratoAssessorRequired: 'Assessor*',
  cadastroContratoEmpresa: 'Empresa',
  cadastroContratoEmpresaRequired: 'Empresa*',
  perfilContrato: 'Perfil do contrato:',
  tipoFluxo: 'Tipo de fluxo:',
  tipoEntidade: 'Tipo de entidade / pessoa:',
  baixeDocumentos: 'Baixe seus documentos:',
  subaDocumentos: 'Suba seus documentos:',
  cadastreSeusDocumentos: 'Cadastre seus documentos:',
  descricaoNaoEncontrada: 'Descrição não encontrada',
  escolhaTipoDocumento: 'Escolha o tipo de documento que deseja baixar:',
  naoDefinido: 'Não definido',
  documentoNaoEcontrado: 'Nenhum documento encontrado.',
  cadastroContratoHintEmpresa:
    'A empresa deve ser cadastrada no menu ‘Empresas’ e posteriormente vinculada no cadastro ‘Assessores Pedagógicos’',
  ultimaAtualizacao: 'Última atualização:',
  cadastroContratoDataInicio: 'Data início do contrato*',
  cadastroContratoDataInicioAditivo: 'Data início*',
  cadastroContratoDataDistrato: 'Data do distrato*',
  cadastroContratoTotalMeses: 'Total de meses',
  totalMesesContratados: 'Total de meses contratados',
  cadastroContratoDataFim: 'Data fim do contrato',
  cadastroContratoDataFimAditivo: 'Data fim*',
  contratoNaoFormalizado: 'Contrato não formalizado',
  contratoStatusNaoLocalizada: 'Situação não localizada.',
  cadastroContratoReembolso: 'Reembolso',
  cadastroContratoValorHora: 'Valor hora',
  cadastroContratoRequiredAssessoria: 'Valor de assessoria é obrigatório',
  cadastroContratoRequiredFormacao: 'Valor de formação é obrigatório',
  cadastroContratoRequiredReuniao: 'Valor de reunião é obrigatório',
  cadastroContratoRequiredProgramasEducacionais: 'o campo de programas educacionais é obrigatório',
  contratoValorAssessoriaRequired: 'Valor hora de Assessoria*',
  contratoValorFormacaoRequired: 'Valor hora de Formação*',
  contratoValorReuniaoRequired: 'Valor hora de Reunião*',
  flgAnaliseJuridica: 'Atestamos que este contrato passou por análise jurídica',
  flgAnaliseJuridicaAceite: 'Atesto que este documento passou por análise jurídica.',
  cadastroContratoValorHoraOf: 'Valor hora de ${1}',
  cadastroContratoAddValorHoraButton: 'Adicionar valor hora',
  cadastroContratoDadosCooperativa: 'Dados da Cooperativa',
  cadastroContratoDadosAssessor: 'Dados do assessor',
  cadastroContratoDadosEntePublico: 'Dados do Ente público',
  cadastroContratoDadosEntePrivado: 'Dados da escola',
  cadastroContratoDadosReembolso: 'Dados do Reembolso ',
  descricaoOutros: 'Descrição Outros',
  obervacoesReembolso: 'Observações',
  cadastroContratoDadosReembolsoHint:
    'Selecione os reembolsos previstos no contrato. Para reembolso com controle de limite diário informe o valor.',
  limiteDiarioReembolsoNaoCadastrado: 'Limite diário não cadastrado.',
  cadastroContratoDadosContrato: 'Dados do contrato',
  cadastroContratoDadosContratoDistrato: 'Dados do distrato',
  cadastroContratoDadosAditivo: 'Dados do aditivo',
  cadastroContratoRevisoes: 'Revisões',
  cadastroContratoOperacional: 'Operacional',
  cadastroContratoAnaliseOperacional: 'Análise Operacional',
  cadastroContratoDownloadChecklists: 'Checklist para Contratação',
  cadastroContratoAssessorDescentralizadoDownloadChecklists:
    'Modelos para contratação',
  cadastroContratoEntePrivadoDescentralizadoDownloadChecklists:
    'Modelos para contratação',
  cadastroContratoArquivos: 'Arquivos',
  cadastroContratoArquivosAtivar: 'Ativar',
  cadastroContratoArquivosDesativar: 'Desativar',
  ativarContrato: 'Ativar',
  desativarContrato: 'Desativar',
  ativarAditivo: 'Ativar aditivo',
  ativarDistrato: 'Ativar distrato',
  diaInvalido: 'Dia inválido.',
  mesInvalido: 'Mês inválido. Deve estar entre 01 e 12.',
  dataInvalida: 'Data inválida.',
  anoInvalido: 'Ano inválido.',
  desativarAditivo: 'Desativar aditivo',
  desativarDistrato: 'Desativar distrato',
  tipoContratoNaoEncontrado: 'Tipo de contrato não encontrado!',

  cadastroContratoDownloadRevisao: 'Download do documento da revisão',
  cadastroContratoArquivosDownloadNaoAssinado:
    'Download do documento não assinado',
  cadastroContratoArquivosDownloadingNaoAssinado:
    'Baixando o documento não assinado',
  cadastroContratoArquivosDownloadAssinado: 'Download do documento assinado',
  cadastroContratoArquivosDownloadingAssinado: 'Baixando o documento assinado',
  cadastroContratoNaoHaDocumentos: 'Não há documentos',
  cadastroContratoExtratos: 'Extratos:',
  cadastroContratoPlanoDeTrabalho: 'Plano de trabalho:',
  cadastroContratoPlanoDeTrabalhoEContratoAssinado: 'Contrato assinado + plano de trabalho:',
  cadastroContratoExtrato: 'Extrato:',
  cadastroContratoCodigo: 'Código',
  cadastroContratoVersao: 'Versão',
  cadastroContratoSituacao: 'Situação',
  cadastroContratoAcoes: 'Ações',
  naoHaArquivos: 'Não há documentos.',
  cadastroContratoArquivosDownloadExtrato: 'Download do extrato',
  cadastroContratoArquivosDownloadingExtrato: 'Baixando o extrato',
  cadastroContratoArquivosDownloadPlanoTrabalho:
    '* Download do plano de trabalho',
  cadastroContratoArquivosDownloadingPlanoTrabalho:
    'Baixando o plano de trabalho',
  arquiviosEntePublicoHint:
    'Extrato é a publicação que o município é responsável de fazer até o quinto dia útil do mês seguinte ao da assinatura. ',
  cadastroContratoArquivosDownloadingValidacao:
    'Baixando o documento para validação',
  cadastroContratoArquivosUploadNaoAssinado: 'Upload do documento não assinado',
  cadastroContratoArquivosUploadingNaoAssinado:
    'Subindo o documento não assinado',
  cadastroContratoArquivosUploadingPlanoTrabalho: 'Subindo o plano de trabalho',
  cadastroContratoArquivosUploadAssinado: 'Upload do documento assinado',
  cadastroContratoArquivosUploadingAssinado: 'Subindo o documento assinado',
  cadastroContratoArquivosUploadExtrato: 'Upload do extrato',
  cadastroContratoArquivosUploadPlanoTrabalho: '* Upload do plano de trabalho',
  cadastroContratoArquivosUploadPlanoTrabalhoSemAsterisco:
    'Upload do plano de trabalho',
  arquiviosEntePublicoPlanoTrabalhoHintBaixo:
    '* Inserir o plano de trabalho somente se não foi enviado no mesmo arquivo que o contrato.',
  cadastroContratoArquivosUploadingExtrato: 'Subindo o extrato',
  cadastroContratoArquivosColumnCodigo: 'Código',
  cadastroContratoArquivosColumnVersao: 'Versão',
  cadastroContratoArquivosColumnSituacao: 'Situação',
  cadastroContratoArquivosColumnAcoes: 'Ações',
  cadastroContratoSelectDocumentoLabelButton: 'Selecionar arquivo',
  cadastroContratoSelectDocumentoHint:
    'Selecione um arquivo para enviar como retorno da análise operacional',
  cadastroContratoUnselectDocumentoLabelButton: 'Remover arquivo',
  cadastroContratoUnselectDocumentoHint:
    'Remover arquivo da análise operacional',
  cadastroContratoFinalizarRevisao: 'Finalizar revisão',
  cadastroContratoHistoricoAnaliseOperacional:
    'Histórico da análise operacional',
  cadastroContratoHistoricoAnaliseOperacionalFileLabel:
    'Essa revisão possui um documento não assinado:',
  cadastroContratoHistoricoAnaliseOperacionalFilePlanoTrabalhoLabel:
    'Essa revisão possui um plano de trabalho:',
  cadastroContratoAnaliseOperacionalJustificativa:
    'Descreva detalhadamente as modificações que deseja efetuar no contrato, indicando a(s) cláusula(s) a ser(em) alterada(s)',
  cadastroContratoDownloadValidacao: 'Download para validação - Contrato',
  cadastroContratoDownloadValidacaoPlanoTrabalho:
    'Download para validação - Plano de Trabalho',
  cadastroContratoDownloadValidacaoEntePublicoAprovado:
    'Última Versão Aprovada - Contratos',
  cadastroContratoDownloadValidacaoEntePublicoAprovadoPlanoTrabalho:
    'Última Versão Aprovada - Plano de Trabalho',
  cadastroContratoDownloadValidacaoEntePublicoRejeitado:
    'Última Versão Revisada - Contratos',
  cadastroContratoDownloadValidacaoEntePublicoRejeitadoPlanoTrabalho:
    'Última Versão Revisada - Plano de Trabalho',
  cadastroContratoEntePublicoIniciarAssinatura: 'Iniciar Processo Assinatura',
  cadastroContratoGerarContrato: 'Gerar contrato',
  cadastroContratoGerarAditivo: 'Gerar aditivo',
  cadastroContratoGerarDistrato: 'Gerar distrato',
  cadastroContratoCriarAditivo: 'Criar aditivo',
  cadastroContratoCriarDistrato: 'Criar distrato',
  cadastroContratoEnviarParaAnalise: 'Enviar para análise operacional',
  cadastroContratoEnviarParaAnaliseSLA:
    'O tempo de atendimento desta solicitação é de 3 dias. Caso seja necessário o parecer jurídico, acrescentar 5 dias. Descreva detalhadamente sua dúvida e/ou ações necessárias.',
  cadastroContratoValidacaoContrato: 'Validação do contrato',
  cadastroContratoValidacaoAditivo: 'Validação do aditivo',
  cadastroContratoValidacaoDistrato: 'Validação do distrato',
  cadastroContratoAnaliseOperacionalContrato: 'Análise operacional do contrato',
  cadastroContratoAnaliseOperacionalAditivo: 'Análise operacional do aditivo',
  cadastroContratoAnaliseOperacionalDistrato: 'Análise operacional do distrato',
  cadastroContratoIrParaVersao: 'Ir para ${1}',
  contratoValidacaoEntePublicoInfoMessageEmEdicao:
    'Você precisa subir um novo arquivo para poder enviar o ${1} para análise operacional.',
  contratoValidacaoEntePublicoInfoMessageAprovado:
    'O documento enviado foi aprovado. Favor utilizar o arquivo que consta no botão "Última Versão Aprovada"',
  contratoValidacaoEntePublicoInfoMessageRejeitado:
    'Foram identificados alguns pontos de atenção. Favor revisar e enviar novamente para análise operacional.',
  contratos: {
    [CONTRATO_VERSAO_CONTRATO_NAME]: {
      name: 'Contrato',
    },
    [CONTRATO_VERSAO_ADITIVO_NAME]: {
      name: 'Aditivo',
    },
    [CONTRATO_VERSAO_DISTRATO_NAME]: {
      name: 'Distrato',
    },
  },

  despesas: 'Despesas',
  adicionarCuponsFiscais: 'Adicionar Cupons Fiscais',

  contratoTipos: {
    [CONTRATO_TIPO_ASSESSOR_NAME]: {
      name: 'Assessores',
    },
    [CONTRATO_TIPO_ENTE_PUBLICO_NAME]: {
      name: 'Ente Público',
    },
    [CONTRATO_TIPO_ENTE_PRIVADO_NAME]: {
      name: 'Ente Privado',
    },
    [CONTRATO_TIPO_ENTE_PRIVADO_REDE_NAME]: {
      name: 'Ente Privado Rede',
    },
  },

  fluxoTipos: {
    [FLUXO_TIPO_CENTRALIZADO_NAME]: {
      name: 'Centralizado',
    },
    [FLUXO_TIPO_DESCENTRALIZADO_NAME]: {
      name: 'Descentralizado',
    },
  },

  contratoNavbarStepNames: {
    [CONTRATO_TIPO_ASSESSOR_NAME]: {
      [CONTRATO_EDIT_ETAPA_DOWNLOAD_CHECKLISTS]: 'Checklists',
      [CONTRATO_EDIT_ETAPA_DADOS]: 'Dados',
      [CONTRATO_EDIT_ETAPA_VALIDACAO]: 'Validação',
      [CONTRATO_EDIT_ETAPA_ANALISE_OPERACIONAL]: 'Análise Operacional',
      [CONTRATO_EDIT_ETAPA_ARQUIVOS]: 'Arquivos',
    },
    [CONTRATO_TIPO_ENTE_PUBLICO_NAME]: {
      [CONTRATO_EDIT_ETAPA_DOWNLOAD_CHECKLISTS]: 'Checklists',
      [CONTRATO_EDIT_ETAPA_DADOS]: 'Dados',
      [CONTRATO_EDIT_ETAPA_VALIDACAO]: 'Validação',
      [CONTRATO_EDIT_ETAPA_ANALISE_OPERACIONAL]: 'Análise Operacional',
      [CONTRATO_EDIT_ETAPA_ARQUIVOS]: 'Arquivos',
    },
    [CONTRATO_TIPO_ENTE_PRIVADO_NAME]: {
      [CONTRATO_EDIT_ETAPA_DADOS]: 'Dados',
      [CONTRATO_EDIT_ETAPA_VALIDACAO]: 'Validação',
      [CONTRATO_EDIT_ETAPA_ANALISE_OPERACIONAL]: 'Análise Operacional',
      [CONTRATO_EDIT_ETAPA_ARQUIVOS]: 'Arquivos',
    },
  },
  nomeFantasia: 'Nome fantasia',
  tipoInstituicao: 'Tipo de Instituição',
  etapasEducacao: 'Etapa da Educação',
  modalidade: 'Modalidade *',
  escolaEditNomeInstituicao: 'Nome Instituição *',
  escolaEditRazaoSocial: 'Razão social *',
  escolaEditCNPJ: 'CNPJ *',
  escolaEditTelefone: 'Telefone *',
  escolaEditCodigoINEP: 'Código INEP',
  escolaEditTipoInstituicao: 'Tipo de instituição *',
  escolaEditEtapasEducacao: 'Etapa da educação *',
  escolaEditModalidade: 'Modalidade',
  escolaEditEmail: 'E-mail *',
  escolaEditCooperativa: 'Cooperativa *',
  escolaEditCep: 'cep *',
  escolaEditEndereco: 'Endereço *',
  escolaEditBairro: 'Bairro *',
  escolaEditEstado: 'Estado *',
  escolaEditCidade: 'Cidade *',
  escolaEditLabelVinculo: "Vínculos",
  escolaEditVinculo: "Vinculada a uma Rede?",
  escolaEditRede: "Rede",
  escolaPlaceholderRede: "Selecione uma rede",
  escolaEditQuestion: "Sua rede ainda não está cadastrada?",
  escolaHelperText: 'O campo "Rede" é obrigatório',
  escolaRedeNameRequired: 'Nome é obrigatório',
  escolaRedeCnpjRequired: 'CNPJ é obrigatório',
  escolaToastSuccess: 'Rede criada com sucesso!',
  razaoSocial: 'Razão social',
  cnpj: 'CNPJ',
  telefone: 'Telefone',
  email: 'E-mail',
  cep: 'CEP',
  endereco: 'Endereço',
  numero: 'Número',
  complemento: 'Complemento',
  bairro: 'Bairro',
  hintRazaoSocial: 'Informar o nome completo da escola',
  hintEtapaDaEducacao: 'Informar etapas que desenvolvem o Programa.',
  hintColaboradoresEscolaEdit:
    'São pessoas da escola que se envolvem nos projetos além dos educadores.',
  inep: 'Código INEP',
  cadastroProfessorNome: 'Nome *',
  cadastroProfessorEmail: 'Email *',
  cadastroProfessorCelular: 'Celular *',
  cadastroProfessorMae: 'Nome da mãe',
  cadastroProfessorDataNascimento: 'Data de nascimento *',
  cadastroProfessorRG: 'RG',
  cadastroProfessorCPF: 'CPF *',
  cadastroProfessorEscolasAtua: 'Escola(s) em que atua *',
  cadastroProfessorEscolasGestor: 'Escola(s) em que é gestor',
  estado: 'Estado',
  cidade: 'Cidade',
  loadingEstados: 'Carregando estados...',
  loadingCidades: 'Carregando cidades...',
  loadingEscolas: 'Carregando escolas...',
  loadingCooperativas: 'Carregando cooperativas...',
  loadingCentrais: 'Carregando centrais...',
  loadingEmpresas: 'Carregando empresas...',
  loadingFormacoes: 'Carregando formações...',
  loadingProgramas: 'Carregando programas...',
  loadingEmpresa: 'Carregando empresa...',
  loadingAssessores: 'Carregando assessores pedagógicos...',
  selecionarEscolaButton: 'Selecionar escola',
  digiteCidade: 'Digite o nome da cidade...',
  digiteEscola: 'Digite o nome da escola...',
  cadastrar: 'Cadastrar',
  salvarEProsseguir: 'Salvar e prosseguir',
  salvar: 'Salvar',
  enviar: 'Enviar',
  duplicar: 'Duplicar',
  deletar: 'Excluir',
  deletarNaoPossivel: 'Não é possível deletar',
  perguntarMaisTarde: 'Perguntar mais tarde',
  cancelButton: 'Cancelar',
  concluirCadastro: 'Concluir cadastro',
  criacaoAditivo: 'Criação de aditivo',
  confirmarCriacaoAditivo: 'Confirmar a criação de aditivo?',
  criacaoDistrato: 'Criação de distrato',
  distrato: 'Distrato',
  aditivo: 'Aditivo',
  contratoAssinado: 'Contrato assinado',
  aditivoAssinado: 'Aditivo assinado',
  distratoAssinado: 'Distrato assinado',
  cadastroDocumentos: 'Cadastro de documentos',
  tipoFluxoObrigatorio: 'Tipo de fluxo é obrigatório',
  tipoContratoObrigatorio: 'Tipo de entidade/pessoa é obrigatório',
  programasEducacionaisObrigatorio: 'Programas educacionais é obrigatório',
  arquivoObrigatorio: 'Arquivo é obrigatório',

  confirmarCriacaoDistrato: 'Confirmar a criação de distrato?',
  desejaConcluirEdicaoDosDadosDesseContrato: 'Deseja concluir o cadastro de dados desse contrato?',
  concluirPesquisa: 'Concluir pesquisa',
  participacaoEssencial: 'Sua participação é essencial para avaliarmos se as mudanças em contratos foram positivas.',
  confirmarConclusaoDaPesquisa: 'Ao confirmar a conclusão da pesquisa, ela não aparecerá novamente pelos próximos 3 meses.',
  confirmar: 'Confirmar',
  confirmButton: 'Sim',
  okButton: 'Ok',
  escolaExistente: 'A escola "${1}" já foi adicionada anteriormente.',
  allEstados: 'Todos os estados',
  escolasEnvolvidasAgenda: 'Escola(s) envolvida(s):',
  agendaAssessorPedagogicoAssessoriaType: 'Assessoria',
  agendaAssessorPedagogicoFormacaoType: 'Formação',
  agendaAssessorPedagogicoReuniaoType: 'Reunião',
  agendaAssessorPedagogicoBloqueioPessoalType: 'Bloqueio Pessoal',
  agendaAssessorPedagogicoOutrosType: 'Outros',
  contratoAssessorPedagogicoAssessoriaType: 'Assessoria*',
  contratoAssessorPedagogicoFormacaoType: 'Formação*',
  contratoAssessorPedagogicoReuniaoType: 'Reunião*',
  contratoAssessorPedagogicoOutrosType: 'Outros',
  agendaAssessorPedagogicoDeleteConfirmTitle: 'Excluindo agenda',
  agendaAssessorPedagogicoDeleteConfirmDescription:
    'Você realmente deseja excluir a agenda?',
  documentoAssinado: 'Documento assinado',
  documentoAssinadoFalta: 'Falta o documento assinado',
  documentoExtratoFalta: 'Falta o documento de extrato',
  documentoAusente: 'Há documentos ausentes',
  documentoExtratoEAssinadoFalta: 'Faltam os seguintes documentos: contrato assinado e extrato.',
  ativar: 'Ativar',
  enviadoEm: 'Enviado em',
  loadMoreCoordenadorButton: 'Carregar mais coordenadores locais...',
  firstLoadingCoordenadoresSearchResult: 'Carregando coordenadores locais...',
  loadingCoordenadoresSearchResult:
    'Carregando resultados de coordenadores locais...',
  loadingMoreCoordenadoresSearchResult:
    'Carregando mais resultados de coordenadores locais...',
  loadMoreProjetoButton: 'Carregar mais projetos...',
  firstLoadingProjetosSearchResult: 'Carregando projetos...',
  loadingProjetosSearchResult: 'Carregando resultados de projetos...',
  loadingMoreProjetosSearchResult: 'Carregando mais resultados de projetos...',
  serchProjetoPlaceholder: 'Digite',
  loadMoreReembolsoButton: 'Carregar mais reembolsos...',
  firstLoadingReembolsosSearchResult: 'Carregando reembolsos...',
  loadingReembolsosSearchResult: 'Carregando resultados de reembolsos...',
  loadingMoreReembolsosSearchResult:
    'Carregando mais resultados de reembolsos...',
  loadingContratoReembolso: 'Carregando contrato ...',
  loadMoreContratoButton: 'Carregar mais contratos...',
  firstLoadingContratosSearchResult: 'Carregando contratos...',
  loadingContratosSearchResult: 'Carregando resultados de contratos...',
  loadingMoreContratosSearchResult:
    'Carregando mais resultados de contratos...',
  loadingArquivos: 'Carregando arquivos...',
  loadingContrato: 'Carregando contrato...',
  loadingAditivo: 'Carregando aditivo...',
  loadingDistrato: 'Carregando distrato...',
  loadMoreAssessorButton: 'Carregar mais assessores pedagógicos...',
  firstLoadingAssessoresSearchResult: 'Carregando assessores pedagógicos...',
  loadingAssessoresSearchResult:
    'Carregando resultados de assessores pedagógicos...',
  loadingMoreAssessoresSearchResult:
    'Carregando mais resultados de assessores pedagógicos...',
  loadMoreEscolaButton: 'Carregar mais escolas...',
  firstLoadingEscolasSearchResult: 'Carregando escolas...',
  loadingEscolasSearchResult: 'Carregando resultados de escolas...',
  loadingMoreEscolasSearchResult: 'Carregando mais resultados de escolas...',
  loadMoreEmpresaButton: 'Carregar mais empresas...',
  firstLoadingEmpresasSearchResult: 'Carregando empresas...',
  loadingEmpresasSearchResult: 'Carregando resultados de empresas...',
  loadingMoreEmpresasSearchResult: 'Carregando mais resultados de empresas...',
  periodo: 'Período',
  loadingPeriodos: 'Carregando períodos...',
  colaboradores: 'Colaboradores(as) da Escola (opcional)',
  profileMenuItemHello: 'Olá, <b>${1}</b>!',
  profileMenuItemEdit: 'Editar perfil',
  profileMenuItemLogout: 'Sair',
  loginTitle: 'Acessar',
  loginUserInputLabel: 'Usuário ou CPF',
  loginPasswordLabel: 'Senha',
  enterButtonLabel: 'Entrar',
  registerButtonLabel: 'Cadastre-se',
  loginRegisterSeparatorText: 'ou',
  prosseguir: 'Prosseguir',
  voltar: 'Voltar',
  changePasswordModalTitle: 'Alterar Senha',
  changePasswordTextIntro:
    'Sua senha foi resetada pelo administrador do sistema. Para prosseguir, você precisa trocar a sua senha.',
  primeiroAcessoModalTitle: 'Primeiro Acesso',
  primeiroAcessoTextIntro:
    'Como esse é o seu primeiro acesso, você precisa trocar a sua senha.',
  primeiroAcessoCPFLabel: 'CPF',
  primeiroAcessoSenhaAntigaLabel: 'Senha atual',
  primeiroAcessoNovaSenhaLabel: 'Nova senha',
  primeiroAcessoRepeatNovaSenhaLabel: 'Repetir nova senha',
  educacaoInfantilLabel: 'Educação Infantil',
  ensinoFundamentalILabel: 'Ensino Fundamental - Anos Iniciais',
  ensinoFundamentalIILabel: 'Ensino Fundamental - Anos Finais',
  ensinoMedioLabel: 'Ensino Médio',
  ensinoMedioLabelCoop: 'Ensino Médio',
  ejaLabel: 'EJA',
  classeEspecializadaLabel: 'Escola Especializada',
  escolaNaoEspecializada: 'Escola não Especializada',
  erroValidacaoPeriodo: 'Erro validação de período',
  erroAoBaixarDocumento: 'Erro ao baixar o documento.',
  errotipoContratoDesconhecido: 'Tipo de contrato desconhecido.',

  erroRotaEntePublicoDescentralizado: 'Erro ao encontrar rota ente-público Descentralizado',
  tipoDeContratoNaoDefinido: 'Tipo de contrato não definido.',
  NenhumaRotaEncontradaParaEstaNotificacao: 'Nenhuma rota encontrada para esta notificação.',
  buscandoNotificacoes: 'Buscando notificações',
  notificacoes: 'Notificações',
  naoHaNotificacoesNovas: 'Não há notificações novas.',
  limparNotificacoes: 'Limpar notificações',
  errorModalAviso: 'Erro ao tentar abrir o modal de aviso.',

  erroDeletarArquivo: 'Erro ao deletar o arquivo.',
  erroValidacaoCampoProf:
    'É necessário informar o número de professores para cada etapa da educação que possua alunos.',
  erroValidacaoCampoAlun:
    'É necessário informar o número de alunos para cada etapa da educação que possua professores.',
  hintEducacaoInfantilProfLabel:
    'A escola especializada é um tipo de instituição que se dedica ao ensino e/ou suporte de alunos com necessidades educativas especiais ou diferenciadas da escola regular. Ex.: APAE.',
  professoresOrientadores: 'Professores orientadores',
  colaboradoresFinancas: 'Colaboradores(as) da Escola (opcional)',
  professoresNotEspec: 'Professores(as) de Escola não Especializada',
  alunosNaoEspecializado: 'Alunos(as) associados de Escola não Especializada',
  educacaoInfantilProfLabel: 'Professores(as) de Educação Infantil',
  ensinoFundamentalIProfLabel:
    'Professores(as) do Ensino Fundamental - Anos Iniciais',
  ensinoFundamentalIIProfLabel:
    'Professores(as) do Ensino Fundamental - Anos Finais',
  ensinoFundamentalIIProfLabelCoop:
    'Professores(as) orientadores(as) do Ensino Fundamental - Anos Finais',
  ensinoFundamentalIIProfLabelFinancas:
    'Professores(as) do Ensino Fundamental - Anos Finais',
  ensinoMedioProfLabel: 'Professores(as) do Ensino Médio',
  ensinoMedioProfLabelCoop: 'Professores(as) orientadores(as) do Ensino Médio',
  ejaProfLabel: 'Professores(as) do EJA',
  escolaEspecializadaProfLabel: 'Professores(as) de Escola Especializada',
  escolaEspecializadaProfLabelCoop:
    'Professores(as) orientadores(as) de Escola Especializada',
  ensinoFundamentalIEstudantesLabel:
    'Estudantes do Ensino Fundamental - Anos Iniciais',
  ensinoFundamentalIIIEstudantesLabel:
    'Estudantes do Ensino Fundamental - Anos Finais',
  ensinoEspecializadoEstudantesLabel: 'Estudantes de Escola Especializada',
  educacaoInfantilAlunLabel: 'Alunos(as) de Educação Infantil',
  ensinoFundamentalIAlunLabel:
    'Alunos(as) do Ensino Fundamental - Anos Iniciais',
  ensinoFundamentalIIAlunLabel:
    'Alunos(as) do Ensino Fundamental - Anos Finais',
  ensinoFundamentalIIAlunLabelCoop:
    'Alunos(as) associados do Ensino Fundamental - Anos Finais',
  ensinoFundamentalIIAlunLabelFinancas:
    'Estudantes do Ensino Fundamental - Anos Finais',
  ensinoFundamentalIProfLabelFinancas:
    'Professores(as) do Ensino Fundamental - Anos Iniciais',
  ensinoFundamentalIAlunLabelFinancas:
    'Estudantes do Ensino Fundamental - Anos Iniciais',
  escolaEspecializadaProfLabelFinancas:
    'Professores(as) de Escola Especializada',
  escolaEspecializadaAlunLabelFinancas: 'Estudantes de Escola Especializada',
  ensinoMedioAlunLabel: 'Alunos(as) do Ensino Médio',
  ensinoMedioAlunLabelCoop: 'Alunos(as) associados do Ensino Médio',
  ejaAlunLabel: 'Alunos(as) do EJA',

  escolaEspecializadaAlunLabel: 'Alunos(as) de Escola Especializada',
  escolaEspecializadaAlunLabelCoop:
    'Alunos(as) associados de Escola Especializada',
  ensinoNaoEspecializadoLabel:
    'Alunos(as) associados de Escola não Especializada',
  newPeriodoTitle: 'Cadastro de anos - A União Faz a Vida',
  editPeriodoTitlePufv: 'Edição de dados do ano da A União Faz a Vida',
  duplicarPeriodoTitlePufv: 'Duplicar os dados do ano da A União Faz a Vida',
  duplicarPeriodoTitleCooperativa: 'Duplicar os dados do ano das Cooperativas Escolares',
  duplicarPeriodoTitleFinancas: 'Duplicar os dados do ano do Finanças na Mochila',
  newPeriodoTitleCoop: 'Cadastro de anos - Cooperativas Escolares',
  newPeriodoTitleFinancas: 'Cadastro de anos - Finanças na Mochila',
  editPeriodoTitleCoop: 'Edição de dados do ano das Cooperativas Escolares',
  editPeriodoTitleFinancas:
    'Edição de dados do Finanças na Mochila nas Escolas',
  editPeriodoTitle: 'Edição de Dados da Escola',
  newIdebTitle: 'Cadastro de IDEB',
  editIdebTitle: 'Edição de IDEB',
  anoIdep: 'Ano',
  cadastroIdebAno: 'Ano',
  cadastroIdebMedia: 'IDEB Observado',
  cadastroIdebMeta: 'Meta',

  loadingProfessor: 'Carregando professor...',
  newProfessorButton: 'Cadastrar Professor',
  dadosDaEscolaTitle: 'Dados da Escola',
  idebTitle: 'IDEB',
  hintCHTotal:
    'Esse campo retorna a carga horária total entre as horas inicial e final informadas anteriormente.',
  hintAtividades: 'Inserir as atividades realizadas na agenda',
  idebHint:
    'Os dados exibidos abaixo são referentes ao Índice de Desenvolvimento da Educação Básica',
  dadosDaEscolaHint:
    'Os dados inseridos abaixo são referentes aos colaboradores(as) da escola, professores(as) e alunos(as) que participaram do programa na escola.',
  dadosDaEscolaEditHint:
    'Os dados inseridos abaixo são referentes aos colaboradores(as) da escola, professores(as) e alunos(as) que participaram do programa na escola.',
  newEscolaTitle: 'Cadastro de Escola',
  editEscolaTitle: 'Edição de Escola',
  newReembolsoTitle: 'Cadastro de Reembolso',
  editReembolsoTitle: 'Edição de Reembolso',
  newProfessorModalTitle: 'Cadastro de Professor',
  editProfessorModalTitle: 'Edição de Professor',
  professorModalHint:
    'Os dados pessoais do professor serão para uso exclusivo nesta ferramenta, não serão utilizados para outros fins e nem divulgados para terceiros sem a devida autorização do usuário.',
  newEscolaButton: 'Cadastrar Escola',
  newEmpresaButton: 'Cadastrar Empresa',
  newIdebButton: 'Cadastrar IDEB',
  backToContratosButton: 'Voltar para Contratos',
  newContratoButton: 'Cadastrar contrato',
  editTemplatesButton: 'Editar templates',
  modelosDeDocumentos: 'Modelos de documentos',
  uploadsDeDocumentos: 'Upload de documentos',
  cadastrarDocumentos: 'Cadastrar documentos',
  newProjetoButton: 'Cadastrar Projeto',
  newReembolsoButton: 'Cadastrar Reembolso',
  newAgendaButton: 'Cadastrar Agenda',
  editAgendaButton: 'Editar Agenda',
  newCoordenadorButton: 'Cadastrar Coordenador Local',
  newAssessorButton: 'Cadastrar Assessor Pedagógico',
  newPeriodoButton: 'Cadastrar Período',
  newVoltarEscolaButton: 'Voltar para escola',
  newAssessorModalTitle: 'Cadastro de Assessor Pedagógico',
  editAssessorModalTitle: 'Edição de Assessor Pedagógico',
  newCoordenadorModalTitle: 'Cadastro de Coordenador Local',
  editCoordenadorModalTitle: 'Edição de Coordenador Local',
  newEmpresaModalTitle: 'Cadastro de Empresa',
  editEmpresaModalTitle: 'Edição de Empresa',
  selectSchoolModalTitle: 'Seleção de escola',
  loadMoreProfessorButton: 'Carregar mais professores...',
  firstLoadingProfessoresSearchResult: 'Carregando professores...',
  loadingProfessoresSearchResult: 'Carregando resultados de professores...',
  loadingMoreProfessoresSearchResult:
    'Carregando mais resultados de professores...',
  disabledUploadAreaText:
    'Você já subiu ${1} arquivos, por isso o upload está temporariamente desativado.',
  imageRemoveLabel: 'Remover imagem',
  videoRemoveLabel: 'Remover vídeo',
  imageUploadError:
    'Erro ao tentar efetuar o upload. Remova esse arquivo e tente novamente.',
  imageRemoveError: 'Erro ao tentar remover imagem ou vídeo upload.',
  imageUploadLimitExeeded: 'Limite de ${1} arquivos atingido.',
  setStepCover: 'Definir se essa imagem será a imagem da capa.',
  videoMaxSizeError:
    'O seu vídeo excedeu o peso máximo para upload que é de ${1}MB.',
  imageMaxSizeError:
    'A sua foto excedeu o peso máximo para upload que é de ${1}MB.',
  imageExtensionError:
    'A sua foto possui uma extensão diferente das aceitas (${1}).',
  videoExtensionError:
    'O seu vídeo possui uma extensão diferente das aceitas (${1}).',
  anyFileExtensionError:
    'O seu arquivo possui uma extensão diferente das aceitas (${1}).',

  hintPreEtapa:
    'Preencha nesta pré-etapa os dados solicitados que serão importantes para identificação do seu projeto.',
  hintPreEtapaTitulo:
    'Insira um pré-título para ajudar a identificar o seu projeto. Na etapa 3 você deverá inserir o título final do projeto.',
  hintEtapa1:
    'Nesta etapa, apresente qual o conjunto de saberes que pretende privilegiar para a organização da expedição investigativa. É a intenção pedagógica baseada no currículo e/ou nos planos de estudo.',
  hintEtapa2_1:
    'Opte por um território que irá suscitar os interesses e o qual os saberes escolares eleitos figurem como potência. A pergunta deve favorecer a exploração dos educandos no território, algo a ser explorado e/ou uma questão.',
  hintEtapa2_2:
    'O objetivo da expedição é coletar informações a respeito do território que foi explorado. Descreva como foi esse processo na expedição realizada e como foi o registro das experiências vividas no território.',
  hintEtapa3:
    'Após a socialização dos registros, as crianças e adolescentes devem ser incentivados a revelar quais os seus interesses de aprendizagem. É a decisão cooperativa dos interesses que dá os subsídios para a eleição da temática e do título do projeto a ser desenvolvido.',
  hintEtapa4:
    'No índice inicial os educandos devem revelar o que já sabem sobre o tema do projeto eleito pelo grupo, descreva aqui os conhecimentos prévios deles. No índice formativo, os educandos expressam os seus interesses de aprendizagem, descreva quais são eles.',
  hintEtapa5:
    'Descreva quais os saberes curriculares estão sendo mobilizados no desenvolvimento deste projeto, estes saberes elucidarão as perguntas realizadas pelos educandos. Não se esqueça da interdisciplinaridade neste momento! Além disso, identifique as atividades e os princípios e valores que estão sendo desenvolvidos no projeto.',
  hintEtapa6:
    'Muitas questões dos educandos podem ser respondidas por meio de pessoas ou entidades da comunidade. Esta etapa é muito importante para a construção do conhecimento em conjunto com os saberes curriculares.',
  hintEtapa7:
    'Descreva as aprendizagens adquiridas neste projeto, este é o indice final. As atividades integradoras são ações que comunicam o que os educandos aprenderam, podem ser de diferentes formas. Relate como foi a deste projeto:',
  hintEtapa8:
    'É um momento muito importante, o qual os educandos compartilham os conhecimentos adquiridos ao longo do projeto. É a etapa de socialização das aprendizagens.',
  hintConsultaPublica:
    'Permitir que este projeto seja visualizado no site após aprovação do assessor.',

  successReproveEventoAgendaAssessorPedagogico:
    'Aprovação da agenda revertida com sucesso!',
  errorReproveEventoAgendaAssessorPedagogico:
    'Erro ao tentar reverter aprovação da agenda!',

  successApproveEventoAgendaAssessorPedagogico: 'Agenda aprovada com sucesso!',
  errorApproveEventoAgendaAssessorPedagogico: 'Erro ao tentar aprovar agenda!',

  successDeleteEventoAgendaAssessorPedagogico: 'Agenda excluída com sucesso!',
  errorDeleteEventoAgendaAssessorPedagogico: 'Erro ao tentar excluir agenda!',

  errorLoadEstados: 'Erro ao tentar carregar os estados!',

  errorAtivarDocumento: 'Erro ao tentar ativar documento.',
  successDesativarDocumento: 'Documento desativado com sucesso.',
  successAtivarDocumento: 'Documento ativado com sucesso.',

  errorDesativarDocumento: 'Erro ao tentar desativar documento.',
  successDownloadDocumentoNaoAssinado:
    'Download do documento não assinado feito com sucesso.',
  errorDownloadDocumentoNaoAssinado:
    'Erro ao tentar efetuar o download do documento não assinado.',
  successDownloadDocumentoAssinado:
    'Download do documento assinado feito com sucesso.',
  errorDownloadDocumentoAssinado:
    'Erro ao tentar efetuar o download do documento assinado.',
  successUploadDocumentoAssinado:
    'Upload do documento assinado feito com sucesso.',
  successUploadDocumento:
    'Documento enviado com sucesso.',
  contratoAssinadoPlanoDeTrabalho: 'Contrato assinado + plano de trabalho',
  aditivoAssinadoPlanoDeTrabalho: 'Aditivo assinado + plano de trabalho',
  distratoAssinadoPlanoDeTrabalho: 'Distrato assinado + plano de trabalho',
  contratoPlanoDeTrabalho: 'Plano de trabalho',
  contratoExtrato: 'Extrato',
  errorUploadDocumentoAssinado:
    'Erro ao tentar efetuar o upload do documento assinado.',
  successDownloadDocumentoValidacao:
    'Download do documento para validação feito com sucesso.',
  errorDownloadDocumentoValidacao:
    'Erro ao tentar efetuar o download do documento para validação.',

  successSendingAnaliseOperacional:
    'Seu contrato será enviado para análise operacional, aguarde retorno por e-mail.',
  errorSendingAnaliseOperacional: 'Erro ao enviar para análise operacional.',
  successReturningAnaliseOperacional: 'Análise operacional concluída.',
  errorReturningAnaliseOperacional: 'Erro ao concluir análise operacional.',
  errorLoadHistoricoAnaliseOperacional:
    'Erro ao tentar carregar histórico da análise operacional.',
  errorLoadContratoArquivos: 'Erro ao tentar carregar lista dos arquivos.',

  errorLoadContratoDocumentosAuxiliares:
    'Erro ao tentar carregar a lista dos checklists!',

  checklistToltip:
    'Aqui você encontra arquivos com orientações para a contratação com Entes Públicos, conforme tipo de contratação.',
  checklistToltipAssessorDescentralizado:
    'Aqui você encontra os modelos para contratação com Assessores Pedagógicos.',
  checklistToltipEntePrivadoDescentralizado:
    'Aqui você encontra os modelos para contratação com Entes Privados.',

  successGerarContrato: 'Contrato gerado com sucesso!',
  errorGerarContrato: 'Erro ao tentar gerar contrato!',

  successGerarAditivo: 'Aditivo gerado com sucesso!',
  errorGerarAditivo: 'Erro ao tentar gerar aditivo!',

  successGerarDistrato: 'Distrato gerado com sucesso!',
  errorGerarDistrato: 'Erro ao tentar gerar distrato!',

  errorFileSizeContrato:
    'O tamanho do arquivo "${1}" excede o tamanho máximo de "${2}"',
  errorFileTypeContrato:
    'O tipo do arquivo "${1}" não é aceito. Os tipos aceitos são "${2}."',

  errorFileSizeDespesaReembolso:
    'O tamanho do arquivo "${1}" excede o tamanho máximo de "${2}"',
  errorFileTypeDespesaReembolso:
    'O tipo do arquivo "${1}" não é aceito. Os tipos aceitos são "${2}."',
  errorLoadReembolso: 'Erro ao tentar carregar reembolso!',
  errorLoadCounterDespesasReembolso:
    'Erro ao tentar atualizar contador de notas da despesa ${1}!',
  errorLoadDespesasReembolso: 'Erro ao tentar carregar despesas de ${1}!',
  errorUploadDespesaReembolso: 'Erro ao tentar fazer upload do arquivo ${1}!',
  errorRemoveDespesaReembolso: 'Erro ao tentar excluir despesa!',
  errorBase64GenerateDespesaReembolso:
    'Erro ao tentar gerar miniatura da despesa!',

  confirmModalRemoveDespesaReembolsoTitle: 'Removendo arquivo de despesa',
  confirmModalRemoveDespesaReembolsoContent: 'Você realmente deseja remover?',
  confirmModalRemoveDespesaReembolsoConfirmLabel: 'Remover',

  confirmModalTitleAviso: 'Aviso',
  confirmModalTitleExcluirDocumento: 'Você tem certeza que deseja excluir os documentos?',
  confirmModalTitleExcluirArquivo: 'Você tem certeza que deseja excluir esse arquivo?',
  confirmModalConfirmButtonSim: 'Sim',
  confirmModalBackButtonNao: 'Não',
  successDeleteDocumento: 'Documento removido com sucesso!',
  errorLoadAgenda: 'Erro ao buscar agenda!',
  errorLoadAgendaDataAtual: 'Erro ao buscar data atual!',
  errorLoadProfessorEditing: 'Erro ao tentar carregar professor!',
  errorLoadEmpresaEditing: 'Erro ao tentar carregar empresa!',
  errorLoadCoordenadorEditing: 'Erro ao tentar carregar coordenador local!',
  errorLoadAssessorEditing: 'Erro ao tentar carregar assessor pedagógico!',
  errorVersaoContrato: 'Versão de contrato desconhecida!',
  errorLoadEscolaEditing: 'Erro ao tentar carregar escola!',
  errorLoadPeriodoEditing: 'Erro ao tentar carregar os dados da escola!',
  errorLoadPeriodosList: 'Erro ao tentar carregar a lista de períodos!',
  errorLoadIdebEditing: 'Erro ao tentar carregar o IDEB',
  errorValidationFiles: 'São aceitos apenas arquivos com as extensões .pdf, .doc e .docx',
  errorLimited10MBFiles: 'O arquivo é muito grande. O tamanho máximo permitido é 10 MB.',
  errorLimited32MBFiles: 'O arquivo é muito grande. O tamanho máximo permitido é 32 MB por arquivo.',
  errorNenhumArquivoValido: 'Nenhum arquivo válido encontrado.',
  errorDeleteDocumento: 'Não foi possível excluir o documento.',

  errorLoadEscolas: 'Erro ao tentar carregar escolas!',
  errorLoadAssessores: 'Erro ao tentar carregar assessores pedagógicos!',
  errorLoadCooperativas: 'Erro ao tentar carregar cooperativas!',
  errorLoadProfessores: 'Erro ao tentar carregar professores!',
  errorLoadEducadores: 'Erro ao tentar carregar educadores!',

  empresasSearchPlaceholder: 'Pesquise por nome da empresa, cnpj ou cidade...',
  contratosSearchPlaceholder: 'Pesquise por número do contrato...',
  escolasSearchPlaceholder: 'Pesquise por nome da escola, cnpj ou cidade...',
  assessoresSearchPlaceholder:
    'Pesquise por nome do assessor pedagógico e cpf...',
  coordenadoresSearchPlaceholder:
    'Pesquise por nome do coordenador local e cpf...',
  professoresSearchPlaceholder:
    'Pesquise por nome do professor, cpf, cidade e escola...',
  reembolsosSearchPlaceholder:
    'Pesquise por descrição ou número do reembolso...',

  addSchoolButtom: 'Adicionar escola',
  addSchoolsButtom: 'Adicionar escolas',

  emptyPeriodosMessage:
    'Os dados desta escola ainda não possuem nenhum período registrado.',
  emptyPeriodosMessageCoopsEcolares:
    'Os dados deste programa escolar Cooperativas Escolares ainda não possuem nenhum período registrado.',
  tooltipCooperativasEscolares:
    'Os dados inseridos abaixo são referentes aos colaboradores(as) da escola, professores(as) e alunos(as) que participam do programa na escola',
  tooltipUniaoFazAVida:
    'Os dados inseridos abaixo são referentes aos colaboradores(as) da escola, professores(as) e alunos(as) que participam do programa na escola',
  cadastroDeDadosDoAnoDoAUniãoFazAVida:
    'Cadastro de dados do ano do A União Faz a Vida',
  cadastroDeDadosDoAnoDoCooperativasEscolares:
    'Cadastro de dados do ano do Cooperativas Escolares',
  CadastroDeDadosDoAnoDoFinancasNaMochila:
    'Cadastro de dados do ano do Finanças na Mochila',
  tooltipFinancasNaMochila:
    'Os dados inseridos abaixo são referentes aos colaboradores(as) da escola, professores(as) e alunos(as) que participam do programa na escola',
  emptyPeriodosMessageFinancasNaMochila:
    'Os dados deste programa escolar Finanças na Mochila ainda não possuem nenhum período registrado.',
  emptyIdebsMessage:
    'Ainda não há nenhuma média de IDEB registrada para esta escola.',

  errorLoadingEmpreaPorCPFAssessor:
    'Erro ao tentar carregar empresa do assessor!',
  errorLoadingMacrosPorTemplateContratos:
    'Erro ao tentar carregar os macros do template!',
  errorLoadingTemplateContratos: 'Erro ao tentar carregar o template!',
  errorSavingTemplateContratos: 'Erro ao tentar salvar o template!',
  errorSearchingTemplatesContratos:
    'Erro ao tentar carregar os templates dos contratos!',
  errorSearchingEmpresas: 'Erro ao tentar buscar empresas!',
  errorSearchingEscolas: 'Erro ao tentar buscar escolas!',
  errorSearchingAssessores: 'Erro ao tentar buscar assessores pedagógicos!',
  errorSearchingDadosDaEscola: 'Erro ao tentar buscar períodos!',
  errorSearchingIdeb: 'Erro ao tentar buscar os dados de IDEB',
  errorSearchingContratos: 'Erro ao tentar buscar contratos!',
  errorSearchingContratoVigente:
    'Erro ao tentar buscar dados do contrato/aditivo vigente.',
  errorSearchingProjetos: 'Erro ao tentar buscar projetos!',
  errorSearchingReembolsos: 'Erro ao tentar buscar reembolsos!',
  errorGenerateProjetoPdf: 'Erro ao tentar gerar o PDF do projeto!',
  errorSearchingDashboard: 'Erro ao gerar o Dashboard!',
  errorSearchingProfessores: 'Erro ao tentar buscar professores!',
  errorSearchingCoordenador: 'Erro ao tentar buscar coordenadores!',

  successReembolsoProjetos: 'Reembolso removido com sucesso!',
  errorReembolsoProjetos: 'Erro ao tentar remover reembolso!',

  successDestivarProjeto: 'Projeto desativado com sucesso!',
  errorDesativarProjetos: 'Erro ao tentar desativar projeto!',

  successAtivarProjeto: 'Projeto ativado com sucesso!',
  errorAtivarProjetos: 'Erro ao tentar ativar projeto!',

  successRemovePeriodo: 'Período removido com sucesso!',
  errorRemovePeriodo: 'Erro ao tentar remover período!',


  errorResponseVolumeDeDados: 'Parece que o volume de dados é muito grande. Aplique mais filtros e tente novamente.', errorCooperativa: 'Erro no valor da cooperativa',
  errorStatus: 'Erro no valor do status',
  errorNoContentRelatorio: 'Não existem dados para serem apresentados',
  loginNotAuthorized: 'Usuário ou senha inválidos.',
  loginHaveNoAccess: 'Esse usuário não possui acesso. Contate o administrador.',
  loginFirstAccess: 'Esse é o seu primeiro acesso...',

  successAprovacao: 'Etapa aprovada com sucesso!',
  errorAprovacao: 'Erro ao tentar aprovar etapa!',

  successReprovacao: 'Inserido Ponto de atenção na etapa com sucesso!',
  errorReprovacao: 'Erro ao tentar inserir Ponto de atenção na etapa!',

  successContratoPreCadastro: 'Contrato criado!',
  erroContratoPreCadastro: 'Erro ao tentar criar contrato!',
  erroContratoUploadFile: 'Erro ao tentar fazer upload do arquivo!',
  erroEditContratoPreCadastro: 'Erro ao tentar editar contrato!',
  erroContratosStep: 'Passo de contrato inválido',
  successContratoSalvar: 'Contrato salvo!',
  successContratoAditivoSalvar: 'Aditivo criado com sucesso!',
  successContratoDistratoSalvar: 'Distrato criado com sucesso!',
  erroContratoSalvar: 'Erro ao tentar criar contrato!',

  successAditivoPreCadastro: 'Aditivo criado!',
  erroAditivoPreCadastro: 'Erro ao tentar criar aditivo!',
  successAditivoSalvar: 'Aditivo salvo!',
  erroAditivoSalvar: 'Erro ao tentar salvar aditivo!',

  successDistratoPreCadastro: 'Distrato criado!',
  erroDistratoPreCadastro: 'Erro ao tentar criar distrato!',
  successDistratoSalvar: 'Distrato salvo!',
  erroDistratoSalvar: 'Erro ao tentar salvar distrato!',

  successCadastrarPreCadastro: 'Pré Cadastro salvo!',
  erroCadastrarPreCadastro: 'Erro ao tentar salvar a pré etapa!',

  successCadastrarEtapa1: 'Etapa 1 salva!',
  erroCadastrarEtapa1: 'Erro ao tentar salvar Etapa 1!',

  successCadastrarEtapa2_1: 'Etapa 2.1 salva!',
  erroCadastrarEtapa2_1: 'Erro ao tentar salvar Etapa 2.1!',

  successCadastrarEtapa2_2: 'Etapa 2.2 salva!',
  erroCadastrarEtapa2_2: 'Erro ao tentar salvar Etapa 2.2!',

  successCadastrarEtapa3: 'Etapa 3 salva!',
  erroCadastrarEtapa3: 'Erro ao tentar salvar Etapa 3!',

  successCadastrarEtapa4: 'Etapa 4 salva!',
  erroCadastrarEtapa4: 'Erro ao tentar salvar Etapa 4!',

  successCadastrarEtapa5: 'Etapa 5 salva!',
  erroCadastrarEtapa5: 'Erro ao tentar salvar Etapa 5!',

  successCadastrarEtapa6: 'Etapa 6 salva!',
  erroCadastrarEtapa6: 'Erro ao tentar salvar Etapa 6!',

  successCadastrarEtapa7: 'Etapa 7 salva!',
  erroCadastrarEtapa7: 'Erro ao tentar salvar Etapa 7!',

  successCadastrarEtapa8: 'Etapa 8 salva!',
  erroCadastrarEtapa8: 'Erro ao tentar salvar a Etapa 8!',

  successCarregarProjeto: 'Projeto carregado!',
  erroCarregarProjeto: 'Erro ao carregar projeto!',

  erroCarregarContrato: 'Erro ao carregar contrato!',
  erroCarregarAditivo: 'Erro ao carregar aditivo!',
  erroCarregarDistrato: 'Erro ao carregar distrato!',

  nenhumTipoFluxoSelect: 'Nenhum tipo de fluxo selecionado',
  loadingTiposFluxos: 'Carregando tipos de fluxo...',
  loadingTipoEntidade: 'Carregando tipo de entidade...',


  nenhumTipoContratoSelect: 'Nenhum tipo de contrato selecionado',
  loadingTiposContratos: 'Carregando tipos de contrato...',

  successCadastrarProfessor: 'Professor cadastrado!',
  erroCadastrarProfessor: 'Erro ao cadastrar professor!',

  successSalvarProfessor: 'Professor salvo!',
  erroSalvarProfessor: 'Erro ao salvar professor!',

  successSalvarPrimeiroAcesso: 'Nova senha salva!',
  erroSalvarPrimeiroAcesso: 'Erro ao salvar nova senha!',

  successCadastrarEmpresa: 'Empresa cadastrada!',
  erroCadastrarEmpresa: 'Erro ao cadastrar empresa!',

  successSalvarEmpresa: 'Empresa salva!',
  erroSalvarEmpresa: 'Erro ao salvar empresa!',

  successCadastrarCoordenador: 'Coordenador local cadastrado!',
  erroCadastrarCoordenador: 'Erro ao cadastrar coordenador local!',

  successSalvarCoordenador: 'Coordenador local salvo!',
  erroSalvarCoordenador: 'Erro ao salvar coordenador local!',

  errorDecodeTokenFromBackend: 'Erro ao tentar acessar o sistema.',
  errorDecodeToken: 'Erro ao tentar acessar o sistema.',

  successCadastrarAssessor: 'Assessor pedagógico cadastrado!',
  erroCadastrarAssessor: 'Erro ao cadastrar assessor pedagógico!',
  confirmModalDeleteAssessorTitle: 'Removendo assessor pedagógico',
  confirmModalDeleteAssessorContent:
    'Você realmente deseja remover o(a) assessor(a)',
  confirmModalDeleteAssessorConfirmlabel: 'Remover Assessor',
  successDeleteAssessor: 'Assessor pedagógico removido com sucesso.',
  errorDeleteAssessor: 'Não foi possível remover o assessor pedagógico.',
  tooltipDeleteAssessor: 'Remover usuário do assessor pedagógico',
  tooltipAssessorProjeto: 'Histórico de projetos do assessor pedagógico',
  selecioneUmaOpcao: 'Por favor, selecione um arquivo e uma opção antes de fazer o upload.',
  error404: 'Ops, não econtramos nada aqui.',
  naoAutorizado: 'Ops, você não tem autorização para continuar.',
  voltaInicio: 'Voltar para o início',

  successSalvarAssessor: 'Assessor pedagógico salvo!',
  erroSalvarAssessor: 'Erro ao salvar assessor pedagógico!',

  successCadastrarAssessoria: 'Agenda do assessor pedagógico cadastrada!',
  erroCadastrarAssessoria: 'Erro ao cadastrar a agenda do assessor pedagógico!',

  successSalvarAssessoria: 'Agenda do assessor pedagógico salva!',
  erroSalvarAssessoria: 'Erro ao salvar a agenda do assessor pedagógico!',

  successCadastrarReembolso: 'Reembolso cadastrado!',
  erroCadastrarReembolso: 'Erro ao cadastrar reembolso!',

  successSalvarReembolso: 'Reembolso salvo!',
  erroSalvarReembolso: 'Erro ao salvar reembolso!',

  successCadastrarEscola: 'Escola cadastrada!',
  erroCadastrarEscola: 'Erro ao cadastrar escola!',

  successSalvarEscola: 'Escola salvo!',
  erroSalvarEscola: 'Erro ao salvar escola!',

  successCadastrarPeriodo: 'Período cadastrado com sucesso!',
  erroCadastrarPeriodo: 'Erro ao cadastrar periodo!',

  successSalvarPeriodo: 'Dados da escola salvos!',
  erroSalvarPeriodo: 'Erro ao salvar dados da escola!',

  successDuplicarPeriodo: 'Dados da escola duplicados com sucesso!',
  erroDuplicarPeriodo: 'Erro ao duplicar dados da escola!',

  successCadastrarIdeb: 'IDEB cadastrado!',
  erroCadastrarIdeb: 'Erro ao cadastrar IDEB!',

  successSalvarIdeb: 'IDEB salvo!',
  erroSalvarIdeb: 'Erro ao salvar IDEB!',

  sucessDeletarIdeb: 'IDEB removido!',
  errorDeletarIdeb: 'Erro ao remover IDEB!',
  errorFiltroAssessor: 'Erro ao fazer a requisição do filtro Assessores',

  erroLogin: 'Erro ao tentar efetuar o login!',

  successRemoverEmpresa: 'Empresa removida com sucesso!',
  errorRemoverEmpresa: 'Erro ao tentar excluir empresa.',

  allEmpresas: 'Todas as empresas',
  warningEditValues:
    'Não é permitido realizar edição em dados relacionados aos anos anteriores.',
  editar: 'Editar valores',
  duplicaValores:
    'Duplicar valores',
  naoPermiteDuplicar: 'Não é permitido duplicar os valores',
  erroAlterarStatusEscola: 'Erro ao tentar alterar o status do escola',
  erroAlterarStatusAssessor:
    'Erro ao tentar alterar o status do assessor pedagógico',
  erroAlterarStatusCoordenador:
    'Erro ao tentar alterar o status do coordenador local',
  erroAlterarStatusProfessor: 'Erro ao tentar alterar o status do professor',
  confirmModalDeleteCoordenadorTitle: 'Removendo Coordenador Local',
  confirmModalDeleteCoordenadorContent:
    'Você realmente deseja remover o(a) coordenador(a) local ',
  confirmModalDeleteCoordenadorConfirmLabel: 'Remover Coordenador',
  successDeleteCoordenador: 'Coordenador Local removido com sucesso.',
  errorDeleteCoordenador: 'Não foi possível remover o coordenador local.',
  tooltipDeleteCoordenador: 'Remover usuário do coordenador local',
  tooltipProjetoCoordenador: 'Histórico de projetos',

  confirmModalDeleteProfessorTitle: 'Removendo Professor',
  confirmModalDeleteProfessorContent:
    'Você realmente deseja remover o(a) professor(a) ',
  confirmModalDeleteProfessorConfirmLabel: 'Remover Professor',
  successDeleteProfessor: 'Usuário removido ou desativado em função dos vínculos no sistema',
  errorDeleteProfessor: 'Não foi possível remover o professor.',
  tooltipDeleteProfessor: 'Remover usuário do professor',
  tooltipProjetosProfessor: 'Histórico de projetos',

  customTextFieldIsLonger:
    'O texto que você digitou excedeu o limite do campo que é de ${1} caracteres. Revise seu texto.',
  customNumberFieldIsLonger:
    'O número que você digitou excedeu o limite do campo que é de ${1} caracteres. Revise seu número.',
  decimalNumberFieldIsLonger:
    'O número que você digitou exedeu o limite de casas decimais que é de ${1}',

  projectRascunhoStatusButtonHint:
    'Uma ou mais etapas ainda não foram preenchidas.',
  projectPendenteStatusButtonHint:
    'Uma ou mais etapas ainda estão pendentes de aprovação.',
  projectRejeitadoStatusButtonHint:
    'Uma ou mais etapas possuem Ponto de atenção.',
  projectAprovadoStatusButtonHint: 'Esse projeto já foi aprovado.',

  esqueciSenha: 'Esqueci a senha',

  refreshingProject: 'Atualizando informações do projeto...',

  escolasLabel: 'Escolas',

  generateAditivo: 'Criar Aditivo',
  modeloDoDocumento: 'Modelo do documento',
  generateDistrato: 'Criar Distrato',

  noChecksTooltip:
    'Este projeto ainda não foi visualizado pelo Coordenador Local nem pelo Professor Gestor.',
  doubleCheckTooltip:
    'Este projeto foi visualizado pelo Coordenador Local e pelo Professor Gestor.',
  coordenadorCheckTooltip:
    'Este projeto foi visualizado apenas pelo Coordenador Local.',
  professorGestorCheckTooltip:
    'Este projeto foi visualizado apenas pelo Professor Gestor.',

  erroProjetoCheckedProf: 'Erro ao tentar marcar o visto do Professor Gestor.',
  erroProjetoCheckedCoordenador:
    'Erro ao tentar marcar o visto do Coordenador Local.',

  projetoChecked: 'Visto marcado!',
  projetoRemoveChecked: 'Visto desmarcado.',

  labelCheckCoordenador: 'Visualizado por Coordenador Local.',
  labelCheckProfessorGestor: 'Visualizado por Professor Gestor.',
  downloadProjetoTooltip: 'Download do projeto para impressão.',
  labelModalDownloadProjeto: 'Download do projeto',
  labelFilterAssessorPedagogico: 'Assessores Pedagógicos',

  sucessDownloadProject: 'Projeto baixado com sucesso.',
  errorDownloadProject: 'Erro ao tentar baixar projeto.',

  anoIdebPlaceholder: 'Ano referente ao IDEB',
  ano: 'Ano',
  reembolsoDespesaValorTotalLabel: 'Valor total',
  reembolsoDescricaoOutros: 'Descrição',
  reembolsoLabelOutros: 'Outros',
  reembolsoLabelHospedagem: 'Hospedagem',
  reembolsoLabelDeslocamento: 'Deslocamento',
  reembolsoLabelDeslocamentoHint: ' Ônibus ou KM rodado',
  reembolsoLabelAlimentacao: 'Alimentação',
  reembolsoLabelPedagio: 'Pedágio',

  errorDescricaoOutros: 'O campo descrição deve ser preenchido.',

  labelButtomCadastrarContratoAssessor: 'Contrato Assessor',
  labelButtomCadastrarContratoEntePublico: 'Contrato Ente Público',
  labelButtomCadastrarContratoEntePrivado: 'Contrato Ente Privado',

  labelButtomCadastrarContratoAssessorDescentralizado: 'Contrato Assessor',
  labelButtomCadastrarContratoEntePublicoDescentralizado:
    'Contrato Ente Público',
  labelButtomCadastrarContratoEntePrivadoDescentralizado:
    'Contrato Ente Privado',
  labelTipoFluxo: 'Tipo de fluxo',
  labelTipoEntidadePessoa: 'Tipo de entidade / pessoa',
  cardAnexoITitle: 'Anexo I',
  concluirUpload: 'Concluir upload',
  uploadContrato: 'Upload de contrato',
  concluir: 'Concluir',
  aviso: 'Aviso',
  criarAditivo: 'Criar aditivo',
  editarAditivo: 'Editar aditivo',
  successContratoAditivoAtualizar: 'Aditivo atualizado com sucesso!',
  successContratoDistratoAtualizar: 'Distrato atualizado com sucesso!',
  criarDistrato: 'Criar distrato',
  editarDistrato: 'Editar distrato',
  cardAtividadesTitle: 'Atividades ',
  atividadesTitleHint:
    'As atividades descritas abaixo referem-se aos valores aportados pelo Ente Privado.',
  cadastroAtividadeButtom: 'Atividade',
  representantesLabel: 'Representante',
  loadingRepresentantesEntePrivado: 'Carregabdo representantes...',
  contratoAssessor: 'Contrato Assessor',
  nenhumRepresentanteCarregado: 'Nenhum representante carregado',
  selecioneUmRepresentante: 'Selecione um representante',
  labelPlanoDeTrabalho: 'Plano de Trabalho',
  cadastroPlanoTrabalhoModalTitle: 'Cadastrar Plano de Trabalho',
  editarPlanoTrabalhoModalTitle: 'Editar Plano de Trabalho',
  cadastroPlanoTrabalhoButtomLabel: 'Salvar Plano de Trabalho',
  linhaOrcamentariaLabel: 'Linha Orçamentária',
  loadingLinhasOrcamentaria: 'Carregando linhas orçamentárias...',
  loadedLinhasOrcamentaria: 'Selecione uma linha orçamentária',
  oqueLabel: 'O que?',
  quandoLabel: 'Quando?',
  quemLabel: 'Quem?',
  porqueLabel: 'Por quê?',
  ondeLabel: 'Onde?',
  comoLabel: 'Como?',
  custoEstimadoLabel: 'Custo Estimado',
  emptyLinhaOrcamentaria: 'Campo linha orçamentária é obrigatório.',
  emptyOque: 'Campo "O que" é obrigatório.',
  emptyQuando: 'Campo "Quando" é obrigatório.',
  emptyQuem: 'Campo "Quem" é obrigatório.',
  emptyPorque: 'Campo "Por Quê" é obrigatório.',
  emptyOnde: 'Campo "Onde" é obrigatório.',
  emptyComo: 'Campo "Como" é obrigatório.',
  confirmDeletePlanoTrabalho:
    'Você realmente deseja remover o plano de trabalho? ',
  campoObrigatorio: '* Campo obrigatório',
  contratosWarningProgressModalLost: 'Você tem certeza que deseja sair dessa página? Todo progresso não salvo será perdido.',
  confirmDeletePlanoTrabalhoModalTitle: 'Remover Plano de Trabalho',
  confirmDeleteAtividade: 'Você realmente deseja remover a atividade? ',
  confirmDeleteAtividadeModalTitle: 'Remover Atividade',
  atividadeLabel: 'Atividade',
  custoLabel: 'Custo estimado',
  emptyAtiviade: 'O campo "Atividade" é obrigatório.',
  emptyCusto: 'O campo "Custo" é obrigatório',
  cadastroAtividadeModalTitle: 'Cadastrar Atividade',
  editarAtividadeModalTitle: 'Editar Atividade',
  cadastroAtividadeButtomLabel: 'Salvar Atividade',
  sucessEditEntePrivado: 'Contrato ente privado editado',
  errorEditEntePrivado: 'Erro ao tentar editar contrato ente privado',
  sucessEditAditivoEntePrivado: 'Aditivo ente privado editado',
  errorEditAditivoEntePrivado: 'Erro ao tentar editar aditivo ente privado',
  erroCarregarDados: 'Erro ao carregar dados',
  relatorioContratoSituacaoLabel: 'Situações de Contrato',

  verificaEscolasSemelhantes: {
    title: 'Sua escola já foi cadastrada?',
    description:
      'Abaixo estão as escolas existentes na mesma cidade informada no cadastro. Verifique nesta listagem se sua escola já está cadastrada. Caso tenha encontrado sua escola, clique em "Fechar" nesta tela e na sequência em [Cancelar] na tela de inclusão do registro para voltar para a listagem. Caso contrário, clique em "Cadastrar escola" para concluir o cadastro.',
    cancelLabelButton: 'Fechar',
    confirmLabelButton: 'Cadastrar escola',
  },

  validaValorHoraAgenda: {
    title: 'Valor Hora Não Configurado',
    description:
      'O tipo de agenda selecionado não possui valor hora configurado no contrato do Assessor Pedagógico. Deseja continuar?',
    cancelLabelButton: 'Fechar',
    confirmLabelButton: 'Cadastrar agenda',
  },

  leftSideBar: {
    main: 'Página inicial',
    projetos: 'Projetos - A União Faz a Vida',
    relatorios: 'Relatórios',
    materiais: 'Materiais Pedagógicos',
    contratos: "Contratos",
    agendaAssessoresPedagogicos: 'Agenda dos Assessores Pedagógicos',
    gestao: "Gestão de cadastros",
    registro_pedagogico: "Registro pedagógico",
    reembolsos: 'Reembolsos',
    pufv: 'A União Faz a Vida',
    cooperativasEscolares: 'Cooperativas Escolares',
    financasNaMochila: 'Finanças na Mochila',
    dashboard: 'Dashboard de Agendamentos',
  },

  agendamentoAssessores: {
    eventStatus0Legend: 'Agendamentos que ainda não aconteceram',
    eventStatus1Legend:
      'Agendamentos que já ocorreram e possuem o campo "Atividade" não preenchido',
    eventStatus2Legend:
      'Agendamentos que já ocorreram, possuem campo "Atividade" preenchido e não estão aprovados',
    eventStatus3Legend:
      'Agendamentos que já ocorreram e foram aprovados ou são bloqueios pessoais',
  },
  dashboardAssessores: {
    title: 'Totais de Agendamentos',
    eventStatus0Legend: 'Agendamentos que ainda não aconteceram',
    eventStatus1Legend:
      'Agendamentos que já ocorreram e possuem o campo "Atividade" não preenchido',
    eventStatus2Legend:
      'Agendamentos que já ocorreram, possuem campo "Atividade" preenchido e não estão aprovados',
    eventStatus3Legend: 'Agendamentos que já ocorreram e foram aprovados',
  },

  modalExperiencia: {
    convite: {
      title: 'Tem novidade na ferramenta!',
      content1: 'Olá!',
      content2: 'Esta pesquisa tem como objetivo entender melhor o perfil de atuação e os desafios de acesso enfrentados pelos usuários da plataforma dos Programas Educacionais.',
      content3: 'É rapidinha — leva só 1 minutinho! 😉',
      content4: 'Suas respostas vão ajudar a melhorar a experiência e garantir que a plataforma atenda às necessidades reais de quem usa no dia a dia.',
    },
    formulario: {
      title: 'Avaliação da experiência',
      question1: 'Quais atividades você realiza atualmente relacionadas aos Programas Educacionais, independentemente do seu perfil cadastrado na plataforma?',
      question1Sub: '(Selecione todas as opções que se aplicam.)',
      question2: 'Você atua em uma região com mais de uma cooperativa Sicredi? Ou em mais de um município?',
      question3: 'Você já teve dificuldade de acesso à plataforma por causa de limitações no seu perfil de usuário?',
      question4: 'Gostaria de compartilhar como você costuma contornar as limitações de acesso por perfil na plataforma?',
      labels: {
        question1: {
          check1: 'Professor',
          check2: 'Professor Gestor',
          check3: 'Coordenador Local',
          check4: 'Assessor Pedagógico',
        },
        question2: {
          radio1: 'Sim',
          radio2: 'Não',
        },
        question3: {
          radio1: 'Sim',
          radio2: 'Não',
          radio3: 'Não sei dizer',
        },
        question4: {
          helper: 'Comentários, sugestões ou relatos de estratégias que você utiliza.',
          placeholder: 'Digite aqui'
        }
      }
    },
    agradecimento: {
      title: '🎉 Pesquisa enviada com sucesso!',
      content1: 'Obrigado por contribuir com a evolução da nossa plataforma 💚',
      content2: 'Sua opinião faz toda a diferença!',
    },
    buttons: {
      fechar: 'Fechar',
      responder: 'Responder',
      finalizar: 'Finalizar',
      carregando: 'Carregando...'
    },
    errors: {
      formularioInvalido: 'Preencha o formulário com as informações obrigatórias.',
      falhaAoEnviar: 'Ocorreu uma falha ao enviar a pesquisa.'
    }
  },
  modalAviso: {
    conteudo: {
      title: 'Atenção!',
      content1: 'Já estão disponíveis os resultados mais recentes de impacto do programa',
      content2: 'A partir de um estudo independente, reunimos evidências que fortalecem decisões e contribuem para qualificar continuamente a nossa atuação.',
      buttons: {
        responder: "Responder",
        acessarEstudo: "Acessar estudo",
        fechar: "Fechar"
      }
    }
  },
  validations: {
    central: {
      required: 'O campo "Central" é obrigatório',
    },
    idProgramasEducacionais: {
      required: 'O campo "Programas educacionais em que atua" é obrigatório.',
    },
    descricao: {
      required: 'O campo "descriçao" é obrigatório.',
    },
    dataAgenda: {
      required: 'O campo "Data da agenda" é obrigatório.',
      validation: 'A Data informada não é válida.',
      hasContratoValidation:
        'Não há contrato ativo com limite de reembolso para esse assessor nesta data.',
    },
    observacoes: {
      required: 'O campo "observações" é obrigatório.',
    },
    reembolsoAllTotalDespesas: {
      required:
        'É necessário declarar valor maior que zero em pelo menos uma das despesas.',
    },
    justificativaAnaliseOperacional: {
      required: 'O campo "justificativa" é obrigatório.',
    },
    assunto: {
      required: 'O campo "Assunto" é obrigatório.',
    },
    descrevaTipoAgenda: {
      required: 'O campo "Descreva o tipo de agenda" é obrigatório.',
    },
    escola: {
      required: 'O campo "Escola" é obrigatório.',
    },
    representante: {
      required: 'O campo "Representante" é obrigatório.',
    },
    ano: {
      required: 'O campo "Ano" é obrigatório.',
      length: 'O campo "Ano" deve possuir 4 caracteres numéricos.',
    },
    media: {
      required: 'O campo "Media" é obrigatório.',
      length:
        'O campo "IDEB Observado" deve ser numérico e possuir um valor entre 0.0 e 10.0',
    },
    meta: {
      required: 'O campo "Meta" é obrigatório.',
      length:
        'O campo "Meta" deve ser numérico e possuir um valor entre 0.0 e 10.0',
    },
    valorAssessoria: {
      required: 'O campo de valor hora de assessoria é obrigatório.',
      validation: 'O campo de valor hora de assessoria não é válido.',
    },
    valorFormacao: {
      required: 'O campo de valor hora de formação é obrigatório.',
      validation: 'O campo de valor hora de formação não é válido.',
    },
    valorOutros: {
      required: 'O campo de valor hora de outros é obrigatório.',
      validation: 'O campo de valor hora de outros não é válido.',
    },
    valorReuniao: {
      required: 'O campo de valor hora de reunião é obrigatório.',
      validation: 'O campo de valor hora de reunião não é válido.',
    },
    assessores: {
      required: 'O campo "Assessor(es) pedagógico(s)" é obrigatório.',
    },
    assessor: {
      required: 'O campo "Assessor pedagógico" é obrigatório.',
    },
    professores: {
      required: 'O campo "Professor(es)" é obrigatório.',
    },
    etapasEnsino: {
      required: 'O campo "Etapa(s) de ensino" é obrigatório.',
    },
    modalidade: {
      required: 'O campo "Modalidade" é obrigatório.',
    },
    principiosValores: {
      required: 'O campo "Princípios e valores" é obrigatório.',
    },
    usuario: {
      required: 'O campo "Usuário ou CPF" é obrigatório.',
    },
    senha: {
      required: 'O campo "Senha" é obrigatório.',
    },
    escolas: {
      required: 'Nenhuma escola selecionada',
    },
    cooperativa: {
      required: 'O campo "Cooperativa" é obrigatório.',
    },
    cooperativas: {
      required: 'O campo "Cooperativas" é obrigatório.',
    },
    idFormacaoAcademicas: {
      required: 'O campo "Formação acadêmica" é obrigatório.',
    },
    situacao: {
      required: 'O campo "Situação" é obrigatório.',
    },
    estado: {
      required: 'O campo "Estado" é obrigatório.',
    },
    cidade: {
      required: 'O campo "Cidade" é obrigatório.',
    },
    nome: {
      required: 'O campo "Nome" é obrigatório.',
      validation:
        'O Nome deve possuir pelo menos duas palavras e não pode conter números.',
    },
    mae: {
      required: 'O campo "Nome da mãe" é obrigatório.',
      validation:
        'O Nome da mãe deve possuir pelo menos duas palavras e não pode conter números.',
    },
    rg: {
      required: 'O campo "RG" é obrigatório.',
      validation: 'O RG informado não é válido.',
    },
    nomeFantasia: {
      required: 'O campo "Nome fantasia" é obrigatório.',
    },
    tipoInstituicao: {
      required: 'O campo "Tipo de Instituição" é obrigatório.',
    },
    etapasEducacao: {
      required: 'O campo "Etapa da Educação" é obrigatório.',
    },
    escolaEditing: {
      required: 'O campo "Etapa da Educação" é obrigatório.',
    },
    birthDate: {
      required: 'O campo "Data de nascimento" é obrigatório.',
      validation: 'A Data de nascimento informada não é válida.',
    },
    tipoAgenda: {
      required: 'O campo "Tipo de Agenda" é obrigatório.',
    },
    empresaAssessor: {
      required:
        'Você precisa selecionar um Assessor com empresa associada a ele.',
      validation: 'Assessor selecionado não possui empresa associada a ele.',
    },
    data: {
      required: 'O campo "Data" é obrigatório.',
      validation: 'A Data informada não é válida.',
    },
    horaInicial: {
      required: 'O campo "Hora Inícial" é obrigatório.',
      validation: 'A Hora Inícial informada não é válida.',
    },
    horaFinal: {
      required: 'O campo "Hora Final" é obrigatório.',
      validation: 'A Hora Final informada não é válida.',
      intervalValidation: 'A Hora Final é inferior ou igual a Hora Inicial.',
      intervaloHoraFinal: 'Hora final do intervalo inválida',
    },
    contratoInicialPeriod: {
      required: 'O campo "Período Inicial" é obrigatório',
      validation: 'O Período Inicial informado não é válido.',
    },
    contratoFinalPeriod: {
      required: 'O campo "Período Final" é obrigatório',
      validation: 'O Período Final é maior ou igual ao Período Inicial.',
    },
    projectInicialPeriod: {
      required: 'O campo "Período Inicial" é obrigatório',
      validation: 'O Período Inicial informado não é válido.',
    },
    projectFinalPeriod: {
      required: 'O campo "Período Final" é obrigatório',
      validation: 'O Período Final é maior ou igual ao Período Inicial.',
    },
    relatorioProjectInicialPeriod: {
      required:
        'O campo "Período Inicial" é obrigatório quando o "Período Final" está preenchido.',
      validation: 'O Período Inicial informado não é válido.',
    },
    relatorioProjectFinalPeriod: {
      required:
        'O campo "Período Final" é obrigatório quando o "Período Inicial" está preenchido.',
      validation:
        'O Período Final é inválido, maior ou igual ao Período Inicial.',
    },
    dataInicio: {
      required: 'O campo "Data de início do contrato" é obrigatório',
      validation: 'A data de início do contrato informada não é válida.',
    },
    dataFim: {
      required: 'O campo "Data do final do contrato" é obrigatório',
      validation: 'A data do final do contrato informada não é válida.',
    },
    totalMeses: {
      required: 'O campo "Total de meses" é obrigatório',
      validation: 'O total de meses informado não é válido.',
    },
    dataDistrato: {
      required: 'O campo "Data do distrato" é obrigatório',
      validation: 'A data do distrato informada não é válida.',
    },
    inicialPeriod: {
      required: 'O campo "Período Inicial" é obrigatório',
      validation: 'O Período Inicial informado não é válido.',
    },
    finalPeriod: {
      required: 'O campo "Período Final" é obrigatório',
      validation: 'O Período Final informado não é válido.',
    },
    period: {
      validation:
        'A data do campo "Período Final" deve ser superior a data do campo "Período Inicial".',
    },
    razaoSocial: {
      required: 'O campo "Razão social" é obrigatório.',
    },
    cnpj: {
      required: 'O campo "CNPJ" é obrigatório.',
      validation: 'O CNPJ informado não é válido.',
    },
    cpf: {
      required: 'O campo "CPF" é obrigatório.',
      validation: 'O CPF informado não é válido.',
    },
    celular: {
      required: 'O campo "Celular" é obrigatório.',
      length:
        'O campo Celular deve conter pelo menos 11 números contando com os dois números do DDD.',
    },
    telefone: {
      required: 'O campo "Telefone" é obrigatório.',
      length:
        'O campo Telefone deve conter pelo menos 10 números contando com os dois números do DDD.',
    },
    inep: {
      required: 'O campo "Código INEP" é obrigatório',
      length: 'o campo Código INEP deve conter ' + INEP_LENGTH + ' números.',
    },
    email: {
      required: 'O campo "E-mail" é obrigatório.',
      validation: 'O E-mail informado não é válido.',
    },
    oldPassword: {
      required: 'O campo "Senha atual" é obrigatório.',
    },
    newPassword: {
      required: 'O campo "nova senha" é obrigatório.',
      validation:
        'A senha deve possuir pelo menos 8 caracteres, possuir número, caracter especial e letras maiúsculas e minúsculas.',
    },
    repeatNewPassword: {
      required: 'O campo "Repetir nova senha" é obrigatório.',
      validation:
        'A senha deve ser igual a senha informada no campo Nova senha.',
    },
    cep: {
      required: 'O campo "CEP" é obrigatório.',
      length: 'O campo CEP deve conter 8 números.',
    },
    endereco: {
      required: 'O campo "endereço" é obrigatório.',
    },
    numero: {
      required: 'O campo "número" é obrigatório.',
      validation: 'O campo Número deve conter somente números.',
      length: 'o campo Número deve conter ' + NUMERO_MAX_LENGTH + ' números.',
    },
    atividades: {
      required: 'O campo "atividades" é necessário para aprovar.',
    },
    bairro: {
      required: 'O campo "bairro" é obrigatório.',
      minLength:
        'O bairro pracisa ter no mínimo ' + BAIRRO_MIN_LENGTH + ' caracteres.',
    },
    periodo: {
      required: 'O campo "período" é obrigatório',
    },
    periodoNumber: {
      required: (label1, label2) => {
        return (
          'O campo de "' +
          label1 +
          '" se torna obrigatório quando há algum valor acima de zero no campo "' +
          label2 +
          '".'
        );
      },
    },
    relatorios: {
      tipo: {
        required: 'O campo "Tipo de relatório" é obrigatório.',
      },
    },
  },

  scheduler: {
    date: 'Data',
    time: 'Tempo',
    event: 'Evento',
    allDay: 'Dia inteiro',
    week: 'Semana',
    work_week: 'Dias úteis',
    day: 'Dia',
    month: 'Mês',
    previous: 'Anterior',
    next: 'Próximo',
    yesterday: 'Ontem',
    tomorrow: 'Amanhã',
    today: 'Hoje',
    agenda: 'Agenda',
    noEventsInRange: 'Não há agendas neste intervalo de tempo.',
    showMore: (total) =>
      total > 1 ? `Mais ${total} agendas` : `Mais ${total} agenda`,
  },
};

export const LANGUAGE_EN_VALUES = {
  ...LANGUAGE_BR_VALUES,
  locale: 'en-US',
  currency: 'USD',
  currencyPrefix: 'US$ ',
  languages: {
    br: 'Portuguese',
    en: 'English',
  },
};

export const LANGUAGE_BR = 'br';
export const LANGUAGE_EN = 'en';

const INITIAL_STATE = {
  languageSelected: LANGUAGE_BR,
  languageValues: LANGUAGE_BR_VALUES,
};

const getVerifiedLanguage = (newLanguage) => {
  switch (newLanguage) {
    case LANGUAGE_BR:
    case LANGUAGE_EN:
      return newLanguage;
    default:
      return LANGUAGE_BR;
  }
};

const getVerifiedlanguageValues = (newLanguage) => {
  switch (newLanguage) {
    case LANGUAGE_BR:
      return LANGUAGE_BR_VALUES;
    case LANGUAGE_EN:
      return LANGUAGE_EN_VALUES;
    default:
      return LANGUAGE_BR_VALUES;
  }
};

export default function LanguageReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case CHANGED_LANGUAGE_ACTION:
      return {
        ...state,
        languageSelected: getVerifiedLanguage(action.payload),
        languageValues: getVerifiedlanguageValues(action.payload),
      };
    default:
      return state;
  }
}
